{
    "401.button": "Reload page",
    "401.subtitle": "You are no longer logged in, your session may have expired. \n Reload the page to log in again and continue where you left off.",
    "401.title": "Access Denied",
    "403.subtitle": "Your Unity account does not have the permission to view this page. \n\n If you have clicked on a category, tag or author page link, you can test this link in the article preview. In order to update the target category, tag or author page, you need a higher access level. You can request it <redirectLink>with this form in the Support Hub</redirectLink>. Select “Modify account“ in “Type of request“.",
    "403.title": "Access denied",
    "404.button": "Back to the homepage",
    "404.subtitle": "The page you're looking for does not exist.",
    "404.title": "Oops!",
    "action.copy.failure": "Copy not supported by your browser",
    "action.copy.success": "Copied successfully!",
    "action.more": "More features",
    "article.action.copyForAuthorisation.disabled.tooltip": "Save the article before copying the text.",
    "article.action.copyForAuthorisation.empty": "There is no paragraph or interview text to copy.",
    "article.action.copyForAuthorisation.error": "The text could not be copied. Please try again.",
    "article.action.copyForAuthorisation.success": "Text copied to clipboard.",
    "article.replaceBreakingnews.modal.confirmButtonText": "Replace breaking news",
    "article.replaceBreakingnews.modal.message": "This article will replace the breaking news \"{{ title }}\". The article will be immediately published with the breakings news’s publication data. This action cannot be undone.",
    "article.replaceBreakingnews.modal.title": "Replace breaking news?",
    "article.replaceBreakingnews.toast.success": "Replaced successfully",
    "article.template.autocomplete.label": "Template",
    "article.template.empty.label": "Empty",
    "article.template.factcheck.label": "Facts check",
    "article.template.interview.label": "Interview",
    "article.template.listicle.label": "Listicle",
    "article.template.opinion.label": "Opinion",
    "article.template.reach.label": "Reach",
    "article.template.reviews.label": "Individual reviews",
    "article.template.standard.label": "Standard",
    "articleForm.summary.modal.cancelButtonText": "No, proceed with save",
    "articleForm.summary.modal.confirmButtonText": "Yes, generate the summary",
    "articleForm.summary.modal.message1": "Would you like to generate an AI summary before saving?",
    "articleForm.summary.modal.message2": "Important: You have to review the summary and save the content again.",
    "articleForm.summary.modal.title": "The article does not contain a summary yet",
    "articles.content.external.message": "This is an external article from {{ externalSystem }} and is read-only.",
    "articles.content.external.title": "{{ externalSystem }} article",
    "articles.list.createButton": "Create article",
    "articles.setup.pageTitle": "New article",
    "articles.transformIntoTicker.button": "Turn into liveticker",
    "articles.transformIntoTicker.modal.confirmationMessage": "This article will be turned into a liveticker content. All texts and settings will be taken over. This action cannot be undone.",
    "articles.transformIntoTicker.modal.confirmationTitle": "Turn into liveticker?",
    "articles.transformIntoTicker.modal.confirmButtonText": "Turn into liveticker",
    "articles.transformIntoTicker.toast.success": "Article successfully transformed",
    "articles.viewEditMode.areYouSure.description": "Another user is already editing this article. If the other user saves the article before you, you will be redirected to the conflict resolution page and will have to choose which content to keep. By clicking the green button you will stay in view mode.",
    "articles.viewEditMode.areYouSure.title": "Are you sure to edit this article?",
    "articles.viewEditMode.edit": "Edit",
    "articles.viewEditMode.emptyArticle": "This article is empty. Switch to edit mode to start writing.",
    "articles.viewEditMode.inactive45minutes.description": "All your changes have been saved. Do you want to switch to view mode?",
    "articles.viewEditMode.inactive45minutes.title": "You have been inactive for more than 45 minutes",
    "articles.viewEditMode.keepEditing": "Keep editing",
    "articles.viewEditMode.otherUserEditing": "{{ otherUser }} is editing this article",
    "articles.viewEditMode.otherUserProofreading.description": "Article cannot be edited by more than one user when in proofreading status",
    "articles.viewEditMode.otherUserProofreading.title": "A user is already proofreading this article",
    "articles.viewEditMode.otherUserSaved": "{{ otherUser }} just saved  this article. You will have to choose between elements from their version and your version once you save.",
    "articles.viewEditMode.otherUsersPresent": "User(s) already present in the article:",
    "articles.viewEditMode.stayInEditMode": "Stay in edit mode",
    "articles.viewEditMode.stayInViewMode": "Stay in view mode",
    "articles.viewEditMode.switchToEditMode": "Switch to edit mode",
    "articles.viewEditMode.switchToViewMode": "Switch to view mode",
    "articles.viewEditMode.unsavedChanges.description": "Before switching back to view mode, please save your changes.",
    "articles.viewEditMode.unsavedChanges.title": "You cannot switch to view mode with unsaved changes",
    "articles.viewEditMode.userPresence.inactive": "Inactive",
    "articles.viewEditMode.userPresence.noChanges": "No changes",
    "articles.viewEditMode.userPresence.saved": "Saved",
    "articles.viewEditMode.userPresence.unsavedChanges": "Unsaved changes",
    "articles.viewEditMode.view": "View",
    "attachmentChooser.button": "Select an attachment",
    "attachmentChooser.noAttachment": "No attachments available",
    "attachmentChooser.or": "or",
    "autocomplete.dropdown.manualOption.use": "Use",
    "backend.commentRiskNotSelected": "Show comments (risk)",
    "backend.emptyCategory": "Category (at least one)",
    "backend.emptyContentName": "Content name",
    "backend.emptyEmbedCode": "Embed code",
    "backend.emptyLead": "Lead",
    "backend.emptyMainTenantId": "Main tenant",
    "backend.emptySeoTeaserTitleLead": "SEO Teaser Title/Lead",
    "backend.emptySlideCredit": "There are slides without credit",
    "backend.emptyTargetDateTime": "Target date and target time can not be empty.",
    "backend.emptyTeaserLead": "Teaser lead",
    "backend.emptyTeaserTitle": "Teaser title",
    "backend.emptyTenant": "Tenant (at least one)",
    "backend.emptyTitle": "Title",
    "backend.emptyUrl": "URL",
    "backend.invalidTargetDateTime": "Valid target date and time",
    "backend.invalidTargetTextLength": "The text falls below or exceeds the target number of characters. Status change is only possible if the target length (+/- 150 characters) is adhered to.",
    "backend.mainCategoryNotSyncedWithDesknet": "The main category is not synced with Kordiam. Please select one that is synced with Kordiam.",
    "backend.noMainCategory": "Main category",
    "backend.noSeoCheckDone": "Run the SEO Helper",
    "backend.noSpellCheckDone": "Run the spellchecker",
    "backend.notSupportedTenantPresent": "This function is not available for at least one of the tenants selected.",
    "backend.noUserNeed": "Start User Needs analysis",
    "backend.onlyOneSeriesAllowed": "Please select max. one category of type Series",
    "backend.unpublishedRelatedContent": "Related contents: In the linked contents the following elements are not published and need to be either removed or set to 'Published': <strong>{{details}}</strong>",
    "backend.wrongArticleProofreadStatus": "Article status needs to be set to 'A_Korrektur/A_Correction'",
    "backend.wrongArticlePublicationStatus": "Article status needs to be set to 'A_Fertig/A_Pret'",
    "backend.wrongNumberOfRelatedContent": "Related content (at least three)",
    "breakingnews.detail.title": "Breaking news content",
    "breakingnews.form.body": "Body",
    "breakingnews.form.lead": "Lead",
    "breakingnews.form.title": "Title",
    "breakingnews.form.titleHeader": "Title header",
    "breakingnews.list.createButton": "Create breaking news",
    "breakingnews.relatedcontent.modalTitle": "Select breaking news to be replaced",
    "breakingnews.relatedcontent.submitButtonText": "Select",
    "breakingnews.setup.pageTitle": "New breaking news",
    "breakingnews.setupForm.modal.confirmationMessage": "The following text will be sent as push message and used as title of the breaking news content:",
    "breakingnews.setupForm.modal.confirmationTitle": "Send push message and publish content?",
    "breakingnews.setupForm.modal.confirmButtonText": "Send & publish",
    "breakingnews.setupForm.pushCategories": "Push categories",
    "breakingnews.setupForm.pushMessage": "Push message",
    "breakingnews.setupForm.submitButton": "Send & publish",
    "breakingnews.setupForm.title": "Setup and push message",
    "breakingnews.transformIntoTicker.button": "Turn into liveticker",
    "breakingnews.transformIntoTicker.message": "Enable writing liveticker posts by turning this breaking news into a liveticker.",
    "breakingnews.transformIntoTicker.modal.confirmationMessage": "This breaking news content will be turned into a liveticker content. All texts and settings will be taken over, including the breaking news label. This action cannot be undone.",
    "breakingnews.transformIntoTicker.modal.confirmationTitle": "Turn into liveticker?",
    "breakingnews.transformIntoTicker.modal.confirmButtonText": "Turn into liveticker",
    "breakingnews.transformIntoTicker.title": "Liveticker posts",
    "breakingnews.transformIntoTicker.toast.success": "Replaced successfully",
    "browserSupportWarning": "You are using a very old version of web browser. This can lead to problems while using Unity CMS and compromise your general online security. Please follow <instructionsLink>these steps</instructionsLink> to update your browser.",
    "category.edit.title": "Edit category",
    "category.form.active": "Active",
    "category.form.activeInfo": "Inactive categories will not be available anymore when selecting categories in Unity. They will not be removed if they have already been selected.",
    "category.form.asyncvalidate.reject": "This name is already taken",
    "category.form.confirmInactivationOfParent": "Deactivating this category will also deactivate all of its sub-categories. Are you sure you want to save?",
    "category.form.expiryDate": "Active until the end of",
    "category.form.modal.confirm": "Confirm",
    "category.form.name": "Name",
    "category.form.notFoundContent": "Category not found",
    "category.form.parentCategory": "Parent category",
    "category.form.syncWithDesknet": "Sync this category to Kordiam",
    "category.form.type": "Type",
    "category.form.type.default": "Default",
    "category.form.type.series": "Series",
    "category.list.createButton": "Create category",
    "category.list.item.expiryDatePrefix": "until {{date}}",
    "category.list.tab.active": "Active",
    "category.list.tab.all": "All",
    "category.list.tab.syncedWithDesknet": "Synced to Kordiam",
    "category.name": "Name",
    "category.parentName": "Parent category",
    "category.setup.title": "Create category",
    "category.type": "Type",
    "collections.all": "All",
    "collections.categoryIds": "Map to these categories when importing",
    "collections.edit.title": "Edit BrixWire keyword",
    "collections.hasCategories": "Has categories assigned",
    "collections.header.title": "Collection",
    "collections.keyword": "Brixwire keyword",
    "collections.noCategories": "No categories",
    "compare.alreadyInConflictNotification": "Oops, looks like somebody saved another version while you were working on this",
    "compare.isInConflictNotification": "There are changes by another user. They have to be reviewed before saving",
    "compare.itemDeleted": "Item deleted",
    "compare.itemNonExisting": "In this revision this content did not exist",
    "compare.revision.itemDeleted": "Item was added in a later revision",
    "compare.revision.itemNonExisting": "In this revision this content does not exist",
    "conflict.headers.changes": "Changes",
    "conflict.headers.changes.description": "Choose which element to keep by checking the box",
    "conflict.headers.changes.lastRevision": "last revision",
    "conflict.headers.changes.yourVersion": "your version",
    "conflict.headers.result": "This will be saved to a new revision",
    "conflict.headers.subtitle": "Please decide which changes should be saved and which changes should be ignored. Do so by clicking the checkboxes on the left, then click save.",
    "conflict.headers.subtitle.tooltip": "Question: Why do I see this screen? Answer: While you've been working on the content, somebody else has also changed and saved edits. Therefore, you have decide which of your edits should be saved. Question What do I have to do now? Answer: The differences are shown on the left-hand side. The box next to the element is used to select which of the elements should appear in the new revision. You can only save once the decision has been made for all elements.",
    "conflict.headers.title": "Somebody else saved this content while you were editing. Some of the changes are conflicting.",
    "conflict.result.chooseMessage": "Choose an element on the left side",
    "conflict.saveButton.tooltip": "Not all decisions have been taken. Select one version for each element on the left.",
    "content.setup.mainCategory": "Main category",
    "content.setup.tenants": "Tenants",
    "contentitem.bookmarkButton": "Bookmark",
    "contentitem.datePrefix.default": "Updated",
    "contentitem.deleteButton": "Delete",
    "contentItem.deletedArticle": "This article has been deleted. It is no longer available and will not be republished.",
    "contentitem.editButton": "Edit",
    "contentitem.fullDatePrefix.default": "on",
    "contentItem.placeholder": "placeholder",
    "contentItem.placeholder.emptyText": "Currently no content available",
    "contentitem.placementHistoryButton": "Placement history",
    "contentitem.previewButton": "Preview",
    "contentitem.publishButton": "publish",
    "contentitem.publishedTimeago": "Published in this category on:",
    "contentLocaleRadioGroup": "Show content from:",
    "contentLocaleRadioGroup.de-CH": "German speaking Switzerland",
    "contentLocaleRadioGroup.description": "You will only see contents (articles, tickers etc.) and tenants of that language.",
    "contentLocaleRadioGroup.fr-CH": "Romandy",
    "contentSelection.buttonLabel": "Select content",
    "contentSelection.column.createdAt": "Created",
    "contentSelection.column.creator": "Creator",
    "contentSelection.column.edit": "Edit",
    "contentSelection.column.tenants": "Tenants",
    "contentSelection.column.title": "Title",
    "contentSelection.column.updatedAt": "Updated",
    "contentSelection.contentItem.published": "Published",
    "contentSelection.modal.submitButton": "Add",
    "contentSelection.modal.title": "Select content",
    "contentStation.header.actions.replaceBreakingnews": "Replace breaking news",
    "contentStation.header.actions.replaceBreakingnews.disabled.tooltip": "Article must be \"Ready to Publish\"",
    "contentStation.header.actions.transformArticleIntoTicker.disabled.tooltip": "Before turning this article into liveticker, please save your changes.",
    "contentStatus": "Content status",
    "contentStatus.draft": "Draft",
    "contentStatus.proofread": "Proofreading",
    "contentStatus.readyToPublish": "Ready to publish",
    "contentStatus.requiredRework": "Rework",
    "contentStatus.review1": "Reread",
    "contentStatus.review2": "Production",
    "contentStatus.seo": "SEO",
    "contentType.articles": "Article",
    "contentType.breakingnews": "Breaking news",
    "contentType.embeds": "Embedded content",
    "contentType.links": "External links",
    "contentType.slideshows": "Slideshow",
    "contentType.tickers": "Liveticker",
    "contentType.videos": "Video",
    "curatedList.abTests.filter.statuses": "Status",
    "curatedList.description": "Select a tab below to see the list tailored for your specific use case. All of them refresh automatically.",
    "curatedList.tab.abTests": "A/B Tests",
    "curatedList.tab.proofreading": "Proofreading",
    "dataGrid.columns": "Select columns",
    "dataGrid.density": "Row density",
    "dataGrid.density.comfortable": "Comfortable",
    "dataGrid.density.compact": "Compact",
    "dataGrid.density.standard": "Standard",
    "dataGrid.resetLayout": "Reset layout",
    "editor.edit.embed.slideshow": "Edit slideshow",
    "editor.embeddedcontent.placeholder.addButton": "Add",
    "editor.embeddedcontent.tooltip": "Some contents may not be rendered here for security reasons. The \"Show preview\" button top-right shows the content as it will be published.",
    "editor.embedWrapperProgress.generateImageAltText": "Generating image alt text...",
    "editor.embedWrapperProgress.generateThumbnail": "Generating thumbnail...",
    "editor.embedWrapperProgress.uploadFile": "Uploading...",
    "editor.headings.tooltip": "Title header should not contain more than 30 characters, title not more than 60 and Lead not more than 140. The lead ideally consists of two sentences.",
    "editor.insert.embed.basicBlocks.crossheadDefault": "Crosshead",
    "editor.insert.embed.basicBlocks.crossheadOrderedListicle": "Listicle ordered",
    "editor.insert.embed.basicBlocks.crossheadSubsection": "Subsection title",
    "editor.insert.embed.basicBlocks.crossheadUnorderedListicle": "Listicle unordered",
    "editor.insert.embed.basicBlocks.p": "Paragraph",
    "editor.insert.embed.bluesky": "Embed Bluesky post",
    "editor.insert.embed.customJson": "Insert custom JSON",
    "editor.insert.embed.dynamicTeaser": "Add dynamic teaser",
    "editor.insert.embed.embeddedContent": "Add embedded content",
    "editor.insert.embed.embeddedSnippet": "Components",
    "editor.insert.embed.facebook": "Embed Facebook post",
    "editor.insert.embed.frontendComponent": "Insert interactive",
    "editor.insert.embed.image": "Add image",
    "editor.insert.embed.importInterview": "Import interview",
    "editor.insert.embed.infobox": "Add infobox",
    "editor.insert.embed.instagram": "Embed Instagram post",
    "editor.insert.embed.interviewSegment": "Interview",
    "editor.insert.embed.poll": "Add poll",
    "editor.insert.embed.quote": "Insert quote",
    "editor.insert.embed.ratingPoll": "Add rating",
    "editor.insert.embed.separator": "Insert horizontal line",
    "editor.insert.embed.slideshow": "Embed slideshow",
    "editor.insert.embed.summary": "Summary",
    "editor.insert.embed.threads": "Embed Threads post",
    "editor.insert.embed.tickerSummary": "Summary",
    "editor.insert.embed.tiktok": "Embed TikTok",
    "editor.insert.embed.twitter": "Embed X post",
    "editor.insert.embed.videoCms": "Embed VideoCMS",
    "editor.insert.embed.youtube": "Embed Youtube video",
    "editor.insert.embed.zattoo": "Embed Zattoo channel",
    "editor.insertToolbar.label.bluesky": "Bluesky",
    "editor.insertToolbar.label.crossheadDefault": "Crosshead",
    "editor.insertToolbar.label.crossheadOrderedListicle": "Listicle ordered",
    "editor.insertToolbar.label.crossheadSubsection": "Subsection title",
    "editor.insertToolbar.label.crossheadUnorderedListicle": "Listicle unordered",
    "editor.insertToolbar.label.customJson": "Custom JSON",
    "editor.insertToolbar.label.dynamicTeaser": "Dynamic teaser",
    "editor.insertToolbar.label.embeddedContent": "Content",
    "editor.insertToolbar.label.embeddedSnippet": "Components",
    "editor.insertToolbar.label.facebook": "Facebook",
    "editor.insertToolbar.label.footer": "Footer",
    "editor.insertToolbar.label.frontendComponent": "Interactive",
    "editor.insertToolbar.label.img": "Image",
    "editor.insertToolbar.label.importInterview": "Import interview",
    "editor.insertToolbar.label.infobox": "Infobox",
    "editor.insertToolbar.label.instagram": "Instagram",
    "editor.insertToolbar.label.interviewSegment": "Interview",
    "editor.insertToolbar.label.p": "Paragraph",
    "editor.insertToolbar.label.poll": "Poll",
    "editor.insertToolbar.label.quote": "Quote",
    "editor.insertToolbar.label.ratingPoll": "Rating",
    "editor.insertToolbar.label.separator": "Separator",
    "editor.insertToolbar.label.slideshow": "Slideshow",
    "editor.insertToolbar.label.summary": "Bullet points",
    "editor.insertToolbar.label.threads": "Threads",
    "editor.insertToolbar.label.tickerSummary": "Paragraphs",
    "editor.insertToolbar.label.tiktok": "TikTok",
    "editor.insertToolbar.label.twitter": "X",
    "editor.insertToolbar.label.videoCms": "Video CMS",
    "editor.insertToolbar.label.youtube": "YouTube",
    "editor.insertToolbar.label.zattoo": "Zattoo",
    "editor.insertToolbar.summary.tooltip": "Only one summary per content can be added.",
    "editor.insertToolbar.tab.content": "Content",
    "editor.insertToolbar.tab.embeds": "Embeds",
    "editor.plugin.a.authorLink.title": "Author",
    "editor.plugin.a.categoryLink.title": "Category",
    "editor.plugin.a.externalLink.title": "External link",
    "editor.plugin.a.insert": "Insert link",
    "editor.plugin.a.internalLink.title": "Content",
    "editor.plugin.a.linkDetails.editButton": "Edit",
    "editor.plugin.a.linkDetails.removeButton": "Remove link",
    "editor.plugin.a.modal.form.externalLink": "External link",
    "editor.plugin.a.modal.form.internalLink": "Internal link",
    "editor.plugin.a.modal.form.reference.label": "Reference",
    "editor.plugin.a.modal.form.url.placeholder": "Paste or type a link",
    "editor.plugin.a.modal.title": "Insert link",
    "editor.plugin.a.remove": "Remove link",
    "editor.plugin.a.selectTarget.button": "Select target",
    "editor.plugin.a.selectTargetModal.authorLink.label": "Author",
    "editor.plugin.a.selectTargetModal.categoryLink.label": "Category",
    "editor.plugin.a.selectTargetModal.internalLink.label": "Content",
    "editor.plugin.a.selectTargetModal.submitButton": "Add",
    "editor.plugin.a.selectTargetModal.tagLink.label": "Tag",
    "editor.plugin.a.selectTargetModal.title": "Select target",
    "editor.plugin.a.tagLink.title": "Tag",
    "editor.plugin.articleBuddy.approve": "Apply",
    "editor.plugin.articleBuddy.category.balancedReporting.description": "Identifies selective omissions or distortions that skew the overall picture. Checks whether relevant facts are missing or context has been manipulated to support a particular narrative.",
    "editor.plugin.articleBuddy.category.balancedReporting.label": "Balanced Reporting",
    "editor.plugin.articleBuddy.category.chartPotential.description": "Flags passages that a Datawrapper chart or map would make clearer. To do this, it analyses the article for chart-ready content and prepares the relevant figures so you can load them directly into the Datawrapper Helper. Any missing data it pulls from reliable public sources with citations.",
    "editor.plugin.articleBuddy.category.chartPotential.label": "Chart potential",
    "editor.plugin.articleBuddy.category.clarity.description": "Flags unexplained jargon, abbreviations, or missing context. Ensures accessibility for a general audience.",
    "editor.plugin.articleBuddy.category.clarity.label": "Clarity",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.description": "Evaluates whether claims are backed by sources and provide sufficient context for understanding. Checks for missing background information or sources and misleading representations.",
    "editor.plugin.articleBuddy.category.contextAndAccuracy.label": "Context & Accuracy",
    "editor.plugin.articleBuddy.category.erase.description": "Marks passages that can be removed entirely to shorten the text without losing essential meaning.",
    "editor.plugin.articleBuddy.category.erase.label": "Erase",
    "editor.plugin.articleBuddy.category.fairness.description": "Checks whether affected parties were given the right to reply and whether the presumption of innocence is respected. Criticism must be fairly framed, without personal attacks or defamation.",
    "editor.plugin.articleBuddy.category.fairness.label": "Fairness",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.description": "Checks for generic masculine forms. Recommends neutral alternatives while respecting named individuals.",
    "editor.plugin.articleBuddy.category.genderInclusiveLanguage.label": "Gender-Inclusive Language",
    "editor.plugin.articleBuddy.category.helvetisms.description": "Ensures consistent use of Swiss Standard German (or French). Replaces foreign variants with correct Swiss expressions.",
    "editor.plugin.articleBuddy.category.helvetisms.label": "Helvetisms",
    "editor.plugin.articleBuddy.category.independence.description": "Evaluates whether reporting is independent of PR influences. Checks for uncritical reproduction of press releases, promotional language, or one-sided presentation of commercial products without critical context.",
    "editor.plugin.articleBuddy.category.independence.label": "Independence",
    "editor.plugin.articleBuddy.category.languageStyle.description": "Checks for nominalizations, passive voice, filler words, clichés, and redundancies. Prefers active, concise phrasing with strong verbs.",
    "editor.plugin.articleBuddy.category.languageStyle.label": "Language & Style",
    "editor.plugin.articleBuddy.category.misspelledNames.description": "Flags person names that appear to be misspelled. Indicates what spelling is likely the correct one. To do this, the tool cross-checks each name via web search against authoritative sources (e.g., institutional websites or Linkedin), taking into account the context from the article.",
    "editor.plugin.articleBuddy.category.misspelledNames.label": "Misspelled names",
    "editor.plugin.articleBuddy.category.nonDiscrimination.description": "Checks whether nationality, ethnicity, religion, or sexual orientation are only mentioned when relevant to the story. Generalizations and stereotypes should be avoided.",
    "editor.plugin.articleBuddy.category.nonDiscrimination.label": "Non-discrimination",
    "editor.plugin.articleBuddy.category.opinionVsFact.description": "Checks whether opinions are clearly marked as such and not presented as facts.",
    "editor.plugin.articleBuddy.category.opinionVsFact.label": "Opinion vs Fact",
    "editor.plugin.articleBuddy.category.paraphrase.description": "Suggests tighter wording or rephrasing that preserves meaning while reducing character count.",
    "editor.plugin.articleBuddy.category.paraphrase.label": "Paraphrase",
    "editor.plugin.articleBuddy.category.pluralism.description": "Evaluates whether different perspectives are represented, especially on controversial topics. Checks for one-sided reporting or lack of diversity in voices and viewpoints.",
    "editor.plugin.articleBuddy.category.pluralism.label": "Pluralism",
    "editor.plugin.articleBuddy.category.privacy.description": "Evaluates the handling of sensitive information and private details. Checks whether human dignity is preserved and privacy is respected.",
    "editor.plugin.articleBuddy.category.privacy.label": "Privacy",
    "editor.plugin.articleBuddy.category.punctuation.description": "Checks correct use of colons, dashes, and other punctuation marks. Flags overuse or misuse.",
    "editor.plugin.articleBuddy.category.punctuation.label": "Punctuation",
    "editor.plugin.articleBuddy.category.quotations.description": "Evaluates whether quotes add value (opinion, emotion, originality). Flags empty or redundant quotes that should be paraphrased or cut.",
    "editor.plugin.articleBuddy.category.quotations.label": "Quotations",
    "editor.plugin.articleBuddy.category.sentenceStructure.description": "Identifies overly long or nested sentences. Recommends breaking them into clear, readable units.",
    "editor.plugin.articleBuddy.category.sentenceStructure.label": "Sentence Structure",
    "editor.plugin.articleBuddy.category.sourceTransparency.description": "Checks whether sources are made transparent and potential conflicts of interest are disclosed. Anonymity must be editorially justified. Hidden lobbying connections or commercial interests must be identifiable.",
    "editor.plugin.articleBuddy.category.sourceTransparency.label": "Source Transparency",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.description": "Evaluates lead strength, logical flow, transitions, and ending quality. Flags missing narrative thread or weak openings/closings.",
    "editor.plugin.articleBuddy.category.structureNarrativeArc.label": "Structure & Narrative Arc",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.description": "Checks for inappropriate colloquialisms, bureaucratic jargon, or biased language. Ensures a neutral, professional tone.",
    "editor.plugin.articleBuddy.category.toneLanguageRegister.label": "Tone & Language Register",
    "editor.plugin.articleBuddy.copyReason": "Copy suggestion details",
    "editor.plugin.articleBuddy.dismiss": "Ignore",
    "editor.plugin.articleBuddy.empty": "Remove text",
    "editor.plugin.basicBlocks.apply": "Text Style",
    "editor.plugin.basicBlocks.crossheadDefault": "Crosshead",
    "editor.plugin.basicBlocks.crossheadDefault.apply": "Crosshead",
    "editor.plugin.basicBlocks.crossheadOrderedListicle": "Listicle ordered",
    "editor.plugin.basicBlocks.crossheadOrderedListicle.apply": "Listicle ordered",
    "editor.plugin.basicBlocks.crossheadSubsection": "Subsection title",
    "editor.plugin.basicBlocks.crossheadSubsection.apply": "Subsection title",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle": "Listicle unordered",
    "editor.plugin.basicBlocks.crossheadUnorderedListicle.apply": "Listicle unordered",
    "editor.plugin.basicBlocks.footer": "Footer",
    "editor.plugin.basicBlocks.footer.apply": "Footer",
    "editor.plugin.basicBlocks.lead.placeholderText": "Lead",
    "editor.plugin.basicBlocks.p.apply": "Paragraph",
    "editor.plugin.basicBlocks.title.placeholderText": "Title",
    "editor.plugin.basicBlocks.titleHeader.placeholderText": "Title header",
    "editor.plugin.blockToolbar.delete": "Delete",
    "editor.plugin.blockToolbar.edit": "Edit",
    "editor.plugin.blockToolbar.rephrase": "Rephrase paragraph text with AI to improve its clarity and readability.",
    "editor.plugin.blockToolbar.rephrase.disabledTooltip": "An empty paragraph text cannot be rephrased.",
    "editor.plugin.bluesky.modal.edit": "Edit Bluesky post",
    "editor.plugin.bluesky.modal.insert": "Insert Bluesky post",
    "editor.plugin.bluesky.modal.submitButton": "Apply",
    "editor.plugin.bluesky.title": "Bluesky",
    "editor.plugin.bold.apply": "Bold",
    "editor.plugin.comment.form.placeholder": "Create a comment...",
    "editor.plugin.comment.insert": "Create comment",
    "editor.plugin.comment.notAvailable": "This comment is not available anymore.",
    "editor.plugin.comment.reply.form.placeholder": "Reply...",
    "editor.plugin.comment.resolve": "Resolve comment",
    "editor.plugin.csSlideshow.modal.edit": "Edit slideshow",
    "editor.plugin.csSlideshow.modal.insert": "Embed slideshow",
    "editor.plugin.csSlideshow.title": "Slideshow",
    "editor.plugin.customJson.message": "Unity doesn't load this element. It can be previewed within the content preview.",
    "editor.plugin.customJson.modal.edit": "Edit custom JSON",
    "editor.plugin.customJson.modal.insert": "Insert custom JSON",
    "editor.plugin.customJson.modal.submitButton": "Apply",
    "editor.plugin.customJson.title": "Custom JSON",
    "editor.plugin.dynamicTeaser.form.addContents": "Add contents",
    "editor.plugin.dynamicTeaser.form.image": "Image",
    "editor.plugin.dynamicTeaser.form.submitButton": "Apply",
    "editor.plugin.dynamicTeaser.modal.edit": "Edit dynamic teaser",
    "editor.plugin.dynamicTeaser.title": "Dynamic teaser",
    "editor.plugin.dynamicTeaser.title.placeholder": "Title",
    "editor.plugin.dynamicTeaser.tooltip": "The dynamic teaser box should always have a title. It should be specific and not generic (like «More about this topic»). The featured articles should inspire users to read more of our content. There should not be more than 3 articles linked in the dynamic teasers.",
    "editor.plugin.embed.noPlaceholder": "No placeholder information found for {{type}}",
    "editor.plugin.embeddedContent.modal.edit": "Embedded content",
    "editor.plugin.embeddedContent.modal.submitButton": "Apply",
    "editor.plugin.embeddedContent.title": "Embedded content",
    "editor.plugin.embeddedContent.tooltip": "Some contents may not be rendered here for security reasons. The \"Show preview\" button top-right shows the content as it will be published.",
    "editor.plugin.embeddedSnippet.modal.edit": "Advanced",
    "editor.plugin.embeddedSnippet.modal.insert": "Components",
    "editor.plugin.embeddedSnippet.title": "Snippet",
    "editor.plugin.enDash.insert": "En dash",
    "editor.plugin.facebook.modal.edit": "Edit Facebook post",
    "editor.plugin.facebook.modal.insert": "Insert Facebook post",
    "editor.plugin.facebook.modal.submitButton": "Apply",
    "editor.plugin.facebook.title": "Facebook",
    "editor.plugin.frontendComponent.form.addButton": "Add property",
    "editor.plugin.frontendComponent.form.removeButton": "Remove property",
    "editor.plugin.frontendComponent.key": "Key",
    "editor.plugin.frontendComponent.logoAlt": "Frontend Component logo",
    "editor.plugin.frontendComponent.message": "Unity doesn't load this element. It can be previewed within the content preview.",
    "editor.plugin.frontendComponent.modal.edit": "Edit interactive",
    "editor.plugin.frontendComponent.modal.insert": "Insert interactive",
    "editor.plugin.frontendComponent.modal.submitButton": "Apply",
    "editor.plugin.frontendComponent.title": "Interactive",
    "editor.plugin.frontendComponent.value": "Value",
    "editor.plugin.guillemets.insert": "Guillemets",
    "editor.plugin.img.form.image": "Cropping & focus point",
    "editor.plugin.img.imageDescription.label": "Alt text",
    "editor.plugin.img.imageDescription.tooltip": "This image alt text is per default generated by AI. In order to update it, please click the pencil button on the left of the image.",
    "editor.plugin.img.modal.edit": "Edit image",
    "editor.plugin.img.modal.insert": "Add image",
    "editor.plugin.img.modal.submitButton": "Add",
    "editor.plugin.img.modal.submitButton.editMode": "Apply",
    "editor.plugin.img.title": "Image",
    "editor.plugin.img.tooltip": "Every image needs a caption and a credit. The caption should contain the most important information about the picture for SEO (Who is in the picture? Where and when was it taken? etc.). Credits are written like this: Foto: Surname, Name (Agency). Or: Foto: Agency. Same for comics and screenshots.",
    "editor.plugin.importInterview.errors": "Some interview elements are invalid. They will be imported as regular paragraphs.",
    "editor.plugin.importInterview.modal.insert": "Import interview",
    "editor.plugin.importInterview.parsedText": "Converted text",
    "editor.plugin.importInterview.sourceText": "Copied text",
    "editor.plugin.importInterview.submitButton": "Convert",
    "editor.plugin.infobox.form.collapsed": "Collapsed",
    "editor.plugin.infobox.form.content": "Content",
    "editor.plugin.infobox.form.title": "Title",
    "editor.plugin.infobox.frame.title": "Infobox",
    "editor.plugin.infobox.modal.edit": "Edit infobox",
    "editor.plugin.infobox.modal.submitButton": "Apply",
    "editor.plugin.infobox.title": "Infobox",
    "editor.plugin.infobox.tooltip": "The infobox must have a title. It should be as specific and descriptive as possible. Bullet points and images are possible within infoboxes, all other elements will not be displayed.",
    "editor.plugin.instagram.modal.edit": "Edit Instagram post",
    "editor.plugin.instagram.modal.insert": "Insert Instagram post",
    "editor.plugin.instagram.modal.submitButton": "Apply",
    "editor.plugin.instagram.title": "Instagram",
    "editor.plugin.interviewSegment.answer.placeholder": "Answer",
    "editor.plugin.interviewSegment.question.placeholder": "Question",
    "editor.plugin.interviewSegment.title": "Interview",
    "editor.plugin.italic.apply": "Italic",
    "editor.plugin.ol.insert": "Numbered list",
    "editor.plugin.poll.answer.placeholder": "Answer",
    "editor.plugin.poll.question.placeholder": "Question",
    "editor.plugin.poll.title": "Poll",
    "editor.plugin.quote.caption.placeholder": "Author",
    "editor.plugin.quote.text.placeholder": "Quote text",
    "editor.plugin.quote.title": "Quote",
    "editor.plugin.quote.tooltip": "A quote has a maximal length of 85 characters. The « and » are not set automatically. If it is a direct quote, in the author field [Surname Name, Role] has to be added (in interviews an exception is possible).",
    "editor.plugin.ratingPoll.form.image": "Image",
    "editor.plugin.ratingPoll.form.name": "Name",
    "editor.plugin.ratingPoll.form.text": "Text",
    "editor.plugin.ratingPoll.modal.edit": "Edit rating poll",
    "editor.plugin.ratingPoll.modal.insert": "Add rating poll",
    "editor.plugin.ratingPoll.modal.submitButton": "Add",
    "editor.plugin.ratingPoll.modal.submitButton.editMode": "Apply",
    "editor.plugin.rephrase.accept": "Accept rephrasing",
    "editor.plugin.rephrase.diff": "Show/hide changes",
    "editor.plugin.rephrase.none": "None",
    "editor.plugin.rephrase.reason": "Explanation",
    "editor.plugin.rephrase.reject": "Reject rephrasing",
    "editor.plugin.rephrase.showLess": "Show less",
    "editor.plugin.rephrase.showMore": "Show more",
    "editor.plugin.singleGuillemets.insert": "Simple guillemets",
    "editor.plugin.slideshow.disabled": "This slideshow has been unpublished and won’t be shown.",
    "editor.plugin.slideshow.disabled.link": "Edit slideshow",
    "editor.plugin.slideshow.disabled.withcontentname": "The slideshow {{slideshowName}} has been unpublished and won’t be shown.",
    "editor.plugin.slideshow.empty.link": "Edit slideshow",
    "editor.plugin.slideshow.empty.message": "There is no slide in this slideshow.",
    "editor.plugin.slideshow.form.author": "Author",
    "editor.plugin.slideshow.form.image": "Teaser image",
    "editor.plugin.slideshow.form.submitButton": "Apply",
    "editor.plugin.slideshow.form.title": "Title",
    "editor.plugin.slideshow.form.updated": "Modified",
    "editor.plugin.slideshow.modal.edit": "Edit slideshow",
    "editor.plugin.slideshow.modal.insert": "Embed slideshow",
    "editor.plugin.slideshow.navigation.next": "Next",
    "editor.plugin.slideshow.navigation.previous": "Previous",
    "editor.plugin.slideshow.title": "Slideshow",
    "editor.plugin.socialEmbed.securityMessage1": "Unity doesn't load {{socialNetworkName}} posts for security reasons.",
    "editor.plugin.socialEmbed.securityMessage2": "If you want to be sure you added the correct post, click this link:",
    "editor.plugin.socialEmbed.securityMessage3": "Click the \"Preview\" button <PreviewIcon /> in the toolbar at the top right to see how the content will be displayed on the website.",
    "editor.plugin.softHyphen.insert": "Soft hyphen",
    "editor.plugin.specialCharacters.insert": "Special characters",
    "editor.plugin.spellChecker.advice": "Advice",
    "editor.plugin.spellChecker.ignore": "Ignore",
    "editor.plugin.spellChecker.noAdvice": "No advice available.",
    "editor.plugin.spellChecker.noProposals": "No proposals for this error",
    "editor.plugin.spellChecker.showLess": "Show less",
    "editor.plugin.spellChecker.showMore": "Show more",
    "editor.plugin.spellChecker.suggestForDictionary": "Suggest for custom dictionary",
    "editor.plugin.spellChecker.suggestionSubmitted": "Thank you. The suggestion will be reviewed by the admin of the dictionary.",
    "editor.plugin.spellChecker.useProposal": "Click to substitute in the editor",
    "editor.plugin.subscript.apply": "Subscript",
    "editor.plugin.subscript2.insert": "Subscript 2",
    "editor.plugin.summary.button.generate": "Generate summary suggestion",
    "editor.plugin.summary.button.generate.tooplip": "Summary suggestion cannot be generated for a blank article.",
    "editor.plugin.summary.button.replace": "Replace with a new suggestion",
    "editor.plugin.summary.error": "An error has occurred while generating summary.\nPlease try again.",
    "editor.plugin.summary.ticker.button.generate": "Generate ticker summary",
    "editor.plugin.summary.ticker.button.replace": "Replace with a new ticker summary",
    "editor.plugin.summary.ticker.longSummary": "Continuous ticker",
    "editor.plugin.summary.ticker.longSummaryTooltip": "This button uses an AI prompt optimised to select and summarise the most relevant and recent entries from the ticker covering several days or even longer.",
    "editor.plugin.summary.ticker.shortSummary": "Event ticker",
    "editor.plugin.summary.ticker.shortSummaryTooltip": "This button uses an AI prompt optimised to summarise events lasting an hour or two, such as press conferences or sporting events.",
    "editor.plugin.summary.title": "Summary",
    "editor.plugin.superscript.apply": "Superscript",
    "editor.plugin.superscript2.insert": "Superscript 2",
    "editor.plugin.superscript3.insert": "Superscript 3",
    "editor.plugin.threads.modal.edit": "Edit Threads post",
    "editor.plugin.threads.modal.insert": "Insert Threads post",
    "editor.plugin.threads.modal.submitButton": "Apply",
    "editor.plugin.threads.title": "Threads",
    "editor.plugin.tiktok.modal.edit": "Edit Tiktok post",
    "editor.plugin.tiktok.modal.insert": "Insert Tiktok post",
    "editor.plugin.tiktok.modal.submitButton": "Apply",
    "editor.plugin.tiktok.title": "Tiktok",
    "editor.plugin.twitter.modal.edit": "Edit Twitter post",
    "editor.plugin.twitter.modal.insert": "Insert Twitter post",
    "editor.plugin.twitter.modal.submitButton": "Apply",
    "editor.plugin.twitter.title": "X",
    "editor.plugin.ul.insert": "Bulleted list",
    "editor.plugin.underline.apply": "Underline",
    "editor.plugin.videoCms.modal.edit": "Edit VideoCMS Embed",
    "editor.plugin.videoCms.modal.insert": "Embed VideoCMS",
    "editor.plugin.videoCms.modal.submitButton": "Apply",
    "editor.plugin.videoCms.title": "Video",
    "editor.plugin.videoCms.tooltip": "To insert a internal video, use the Unity embed code from the video CMS. Every video needs a caption and a credit. Credits are written like this: Video: Surname, Name (Agency). Or: Video: Agency.",
    "editor.plugin.youtube.modal.edit": "Edit Youtube post",
    "editor.plugin.youtube.modal.insert": "Insert Youtube post",
    "editor.plugin.youtube.modal.submitButton": "Apply",
    "editor.plugin.youtube.title": "Youtube",
    "editor.plugin.zattoo.form.channel": "Select Zattoo Channel",
    "editor.plugin.zattoo.modal.edit": "Zattoo",
    "editor.plugin.zattoo.modal.insert": "Embed Zattoo channel",
    "editor.plugin.zattoo.modal.submitButton": "Apply",
    "editor.plugin.zattoo.title": "Zattoo",
    "editor.stickyToolbar.counter.element": "Element's characters: {{ quantity }}",
    "editor.stickyToolbar.counter.total": "Total characters: {{ quantity }}",
    "editor.stickyToolbar.counter.warning": "The text is more than 150 characters longer than agreed. Please shorten the article.",
    "editor.validation.titleHeader.maxLength": "Title header must be at most {{maxLength}} letters or symbols",
    "editor.validation.uploading": "Saving is not possible, until all elements are fully loaded.",
    "elementForm.modal.deleteMessage": "Should the component really be deleted? The component will be removed from all content.",
    "embed.captionTitle": "Caption title",
    "embed.code": "Embed code",
    "embed.customJson.json": "JSON",
    "embed.fallBackHeight": "Fallback height",
    "embed.frontendComponent.alt": "Content for search engines",
    "embed.frontendComponent.label": "Label",
    "embed.frontendComponent.properties": "Properties",
    "embed.frontendComponent.source": "Script URL",
    "embed.iframe": "IFrame",
    "embed.iframe.preview.broken": "The iFrame cannot be displayed.",
    "embed.includeCaption": "Include caption",
    "embed.infobox.default": "Default",
    "embed.infobox.important": "Important",
    "embed.infobox.summary": "Summary",
    "embed.url": "URL",
    "embeddedcontent.iframe.error": "This URL may not be working. It has to be verified in the preview.",
    "embeddedcontent.iframe.error.500": "The server of Unity is currently not available, please retry later",
    "embeddedSnippet.component": "Component",
    "embeddedSnippet.copy": "Insert copy",
    "embeddedSnippet.copyedit.link": "Inserts a copy of the selected component that can be freely edited.",
    "embeddedSnippet.copyedit.unlink": "Embeds the selected component and will stay in sync with the original. Cannot be edited.",
    "embeddedSnippet.description": "To be able to edit this component, the component must be copied. Changes to the copy do not affect the original component.",
    "embeddedSnippet.embed": "Embed original",
    "embeddedSnippet.noSelection": "Select a component to see a preview.",
    "embeddedSnippet.preview": "Preview",
    "emptySlideCredit": "Missing credit",
    "errorPage.button": "Back to the homepage",
    "errorPage.subtitle": "Sorry, an unexpected error has occurred. Click the button below to return to the homepage.",
    "errorPage.title": "Oops!",
    "externalcontent.embeds.actions.create": "Create embedded content",
    "externalcontent.embeds.detail.editButton": "Edit embedded content details",
    "externalcontent.embeds.detail.title": "Embedded content details",
    "externalcontent.embeds.form.lead": "Lead",
    "externalcontent.embeds.form.preview": "Preview",
    "externalcontent.embeds.form.title": "Title",
    "externalcontent.embeds.form.titleHeader": "Title header",
    "externalcontent.embeds.form.url": "URL",
    "externalcontent.embeds.setup.pageTitle": "New embedded content",
    "externalcontent.embeds.title": "Embedded contents",
    "externalcontent.links.actions.create": "Create external content",
    "externalcontent.links.detail.editButton": "Edit external link details",
    "externalcontent.links.detail.title": "External link details",
    "externalcontent.links.form.openinnewwindow": "Open in new window",
    "externalcontent.links.form.url": "External URL",
    "externalcontent.links.setup.pageTitle": "New external link",
    "externalcontent.links.title": "External links",
    "externalcontent.links.type": "Type",
    "externalcontent.links.type.deepLink": "Deep link",
    "externalcontent.links.type.url": "URL",
    "externalcontent.videos.detail.editButton": "Edit video details",
    "externalcontent.videos.detail.title": "Video details",
    "externalcontent.videos.list.createdButton": "Create video",
    "externalcontent.videos.list.pageTitle": "Videos",
    "feedback.evaluation.downvote": "Downvote",
    "feedback.evaluation.upvote": "Upvote",
    "fileUploadDropArea.ariaLabel": "Image drop area",
    "fileUploadDropArea.criteria.description": "Only the following file formats are allowed in the maximum size listed below:",
    "fileUploadDropArea.loading.status": "{{done}} of {{total}} {{unit}} uploaded ({{progress}}%)",
    "fileUploadDropArea.loading.status.bytes": "bytes",
    "fileUploadDropArea.loading.status.files": "files",
    "fileUploadDropArea.loading.title": "Uploading",
    "fileUploadDropArea.multiple.text": "Drop images here to upload",
    "fileUploadDropArea.multiple.upload": "Upload images",
    "fileUploadDropArea.single.text": "Drop image here to upload",
    "fileUploadDropArea.single.upload": "Upload image",
    "form.cancelButton": "Cancel",
    "form.changes.restored": "Unsaved changes restored",
    "form.closeButton.tooltip": "Close",
    "form.deleteButton": "Delete",
    "form.fields.error": "Error on saving. Please check your entries.",
    "form.fields.urlIframe.placeholder": "URL or Iframe (https)",
    "form.modal.cancelMessage": "Are you sure you want to cancel? Your changes will be discarded.",
    "form.modal.cancelTitle": "Cancel",
    "form.modal.deleteMessage": "Are you sure you want to delete this element?",
    "form.modal.deleteTitle": "Delete",
    "form.stepInput.decrease": "increase",
    "form.stepInput.increase": "decrease",
    "form.submitButton": "Save",
    "geneeaEntitiesAutocomplete.noneFound": "No entities found",
    "geneeaEntityForm.assignTag.hint": "Once you assign a tag, articles marked with this entity will automatically appear on this tag's page. The dropdown list above only displays entities without any tags assigned.",
    "geneeaEntityForm.assignTag.label": "Tag",
    "geneeaEntityForm.assignTag.title": "Assign existing tag",
    "geneeaEntityForm.createTag.form.active": "Active",
    "geneeaEntityForm.createTag.form.allowRobots": "Show in search engines",
    "geneeaEntityForm.createTag.form.asyncvalidate.reject": "This name is already taken",
    "geneeaEntityForm.createTag.form.description": "Description",
    "geneeaEntityForm.createTag.form.geneeaEntity.hint": "Articles marked with this entity automatically appear on this tag’s page. If you don’t want this to happen, remove the entity above and save changes.",
    "geneeaEntityForm.createTag.form.geneeaEntity.label": "Assigned entity",
    "geneeaEntityForm.createTag.form.image": "Image",
    "geneeaEntityForm.createTag.form.name": "Name",
    "geneeaEntityForm.createTag.form.title": "Title",
    "geneeaEntityForm.createTag.title": "Create new tag",
    "geneeaEntityForm.or": "or",
    "geneeaEntityList.filter.all": "All",
    "geneeaEntityList.filter.assigned": "Tag assigned",
    "geneeaEntityList.filter.unassigned": "No tag",
    "geneeaEntityList.name": "Name",
    "geneeaEntityList.tag": "Tag assigned",
    "geneeaEntityList.totalCount": "No. articles",
    "geneeaEntityList.type": "Type",
    "home.title.greetings": "how are you today?",
    "home.title.hello": "Hello {{name}},",
    "home.widget.releaseNotes": "Release note",
    "home.widget.relevantSystems": "Relevant systems",
    "icon.pin.title": "Pin",
    "image.caption": "Caption",
    "image.credit": "Credit",
    "image.description": "Image description",
    "image.focusPoint.title": "Focus point",
    "image.style.image": "Image",
    "image.style.infographic": "Graphic",
    "kickword.edit.title": "Edit kickword",
    "kickword.form.asyncvalidate.reject": "This name is already taken",
    "kickword.form.color.background": "Background color",
    "kickword.form.color.border": "Border color",
    "kickword.form.color.placeholder": "Hex color code (e.g. #DDEE55)",
    "kickword.form.color.text": "Text color",
    "kickword.form.name": "Name",
    "kickword.list.addButton": "Create kickword",
    "kickword.setup.title": "Create kickword",
    "kickword.title": "Kickwords",
    "league.edit.title": "Edit league or tournament",
    "league.form.nameEnglish": "League or tournament name (English)",
    "league.form.nameFrench": "League or tournament name (French)",
    "league.form.nameGerman": "League or tournament name (German)",
    "league.form.radio.item.iceHockey": "Ice hockey",
    "league.form.radio.item.soccer": "Soccer",
    "league.form.radio.title.sport": "Sport",
    "league.setup.title": "Create league or tournament",
    "list.noresult": "No results found",
    "maintenancenotes.form.note": "Add note (home screen)",
    "maintenancenotes.form.notification": "Add note (notification bar)",
    "maintenancenotes.form.status": "Status",
    "maintenancenotes.form.title": "Maintenance note",
    "maintenancenotes.status.available": "Available",
    "maintenancenotes.status.maintenance": "Maintenance",
    "maintenancenotes.title": "Unity system status",
    "metadata.action.copy.success": "Copied successfully!",
    "metadata.users.minCharacters": "Please enter at least 2 characters",
    "metadata.users.nonefound": "No users found",
    "metadataHistory.closeButton.title": "Close",
    "metadataHistory.contentStatus": "Content status",
    "metadataHistory.fieldName": "Field name",
    "metadataHistory.newValue": "New value",
    "metadataHistory.operation": "Operation",
    "metadataHistory.operation.added": "Added",
    "metadataHistory.operation.removed": "Removed",
    "metadataHistory.operation.updated": "Updated",
    "metadataHistory.publicationStatus": "Publication status",
    "metadataHistory.tenant": "Tenant",
    "metadataHistory.tenant.default": "Default",
    "metadataHistory.title": "Metadata history",
    "metadataHistory.updated": "Updated",
    "metadataHistory.updatedBy": "Updated by",
    "metadataHistory.value.off": "OFF",
    "metadataHistory.value.on": "ON",
    "metadataHistory.value.placeholder": "Cannot be displayed here",
    "metaform.additionalsettings.adsEnabled": "Show ads",
    "metaform.additionalsettings.aiGenerated": "AI-generated",
    "metaform.additionalsettings.allowRobots": "Show in search engines",
    "metaform.additionalsettings.authorBiographyDisplayed": "Show biography",
    "metaform.additionalsettings.breakingNews": "Breaking",
    "metaform.additionalsettings.commentingEnabled": "Show comments",
    "metaform.additionalsettings.commentRisk": "Comment risk",
    "metaform.additionalsettings.commentRisk.high": "High-risk",
    "metaform.additionalsettings.commentRisk.low": "Low-risk",
    "metaform.additionalsettings.confirmDisableAds.content": "Are you sure you want to deactivate ads?",
    "metaform.additionalsettings.confirmDisableAds.title": "Deactivate ads",
    "metaform.additionalsettings.contest": "Contest",
    "metaform.additionalsettings.feedbackEnabled": "Show feedback",
    "metaform.additionalsettings.group1": "Type of content",
    "metaform.additionalsettings.group2": "Display content",
    "metaform.additionalsettings.headDisabled": "Headerless",
    "metaform.additionalsettings.likesEnabled": "Show likes",
    "metaform.additionalsettings.live": "Live",
    "metaform.additionalsettings.newsletterSubscribingEnabled": "Show newsletter subscription",
    "metaform.additionalsettings.opinion": "Opinion",
    "metaform.additionalSettings.opinion.tooltip": "This toggle activates opinion style for the article. Please select the type of opinion from the drop-down menu.",
    "metaform.additionalsettings.opinionType": "Opinion type",
    "metaform.additionalsettings.podcast": "Podcast",
    "metaform.additionalsettings.premium": "Premium",
    "metaform.additionalsettings.publicationDateExposed": "Show date",
    "metaform.additionalsettings.readAloudEnabled": "Show Read Aloud",
    "metaform.additionalsettings.renderedInWebView": "App: show in web view",
    "metaform.additionalsettings.sharingEnabled": "Show sharing",
    "metaform.additionalsettings.syndication": "Syndication",
    "metaform.additionalsettings.title": "Advanced settings",
    "metaform.additionalsettings.translation": "Translation",
    "metaform.additionalsettings.videoInContent": "Video",
    "metaform.additionalsettings.visibleInNewestContent": "Show in newest contents",
    "metaform.authors.addButton": "Add",
    "metaform.authors.additionalInfo": "Additional info",
    "metaform.authors.agency": "Agency",
    "metaform.authors.author": "Author",
    "metaform.authors.contributor": "Contributor",
    "metaform.authors.name": "Name",
    "metaform.authors.photographer": "Photographer",
    "metaform.authors.removeButton": "Delete",
    "metaform.authors.service": "Service",
    "metaform.authors.title": "Authors",
    "metaform.authors.title.tooltip": "Please add all authors of the article. To not show an author in the byline, but still let them be tracked for ProLitteris the type «contributor» can be used. If an agency is added, it will only show the abbreviation of the author. Authors without dropdown entry can be added as external authors. To add external authors please contact the Product-Team in this Slack-Channel: #helpline_disco. <spacer /> <linkIcon /> <linkComponent href='https://tamedia.slack.com/archives/CTGHWRT3K'>Link</linkComponent",
    "metaform.authors.type": "Type",
    "metaform.category.notFoundContent": "No results found",
    "metaform.emailAlerts.label": "Enable sending of email alert",
    "metaform.emailAlerts.tooltip.alreadyEnabled": "Sending of email alert has been enabled. It cannot be disabled again.",
    "metaform.emailAlerts.tooltip.disabled": "At least one tag needs to be selected for email alert to be sent. Alerts can only be sent once per ticker.",
    "metaform.fixedmenubar.metadataHistory": "Metadata history",
    "metaform.fixedmenubar.placementHistory": "Placement history",
    "metaform.fixedmenubar.preview": "Show preview",
    "metaform.fixedmenubar.restore": "Restore",
    "metaform.fixedmenubar.save": "Save changes",
    "metaform.hreflang.addButton": "Add",
    "metaform.hreflang.title": "Hreflang",
    "metaform.hreflang.title.tooltip": "Hreflang tags you configure here are delivered on the website, alongside the rest of the article’s metadata. Each line defines a locale (a set of region+language) and URL. Search engines use this data to provide URL matching current user location and language in search results.",
    "metaform.infobox.button": "Add infobox",
    "metaform.infobox.field.content": "Content",
    "metaform.infobox.field.title": "Title",
    "metaform.infobox.item.editButton": "Edit infobox",
    "metaform.infobox.modal.title": "Infobox",
    "metaform.infobox.title": "Infobox",
    "metaform.infobox.title.tooltip": "This infobox Is shown always at the end of the article with a grey background and expanded. Inside of this infobox you can use all components and elements. The title is optional.",
    "metaform.kickword.nonefound": "No more kickwords found",
    "metaform.kickword.placeholder": "Select kickword",
    "metaform.kickword.title": "Kickword",
    "metaform.modal.confirm": "Confirm",
    "metaform.note.placeholder": "Add a note",
    "metaform.note.title": "Note",
    "metaform.note.title.tooltip": "This note field is only for internal use. For example for remarks if a content is taken offline or for temporary workflow comments. It is not shown publicly anywhere.",
    "metaform.placement.categories": "Categories",
    "metaform.placement.categories.placeholder": "Select categories...",
    "metaform.placement.categories.tooltip": "The article is placed in every chosen category, the main category should be the most fitting one. It’s important for automatisation, campaigns, tracking and is highlighted in the navigation.",
    "metaform.placement.editorialOrigin": "Editorial Origin",
    "metaform.placement.editorialOrigin.agency": "Agency",
    "metaform.placement.editorialOrigin.mantel": "Mantel",
    "metaform.placement.editorialOrigin.mantel_reach": "Mantel + Reach",
    "metaform.placement.editorialOrigin.national": "National",
    "metaform.placement.editorialOrigin.reach": "Reach",
    "metaform.placement.editorialOrigin.regional": "Regional",
    "metaform.placement.editorialOrigin.regional_reach": "Regional + Reach",
    "metaform.placement.editorialOrigin.tooltip": "The distinction is important for data analysis. Example for classification: texts from the editorial teams of BaZ, BZ, or Der Bund are assigned the category «Regional». Texts from the local sections of the Tages-Anzeiger are also classified as «Regional». Articles from sections such as Ressort Inland, which are produced for all titles, are categorized as «Mantel». News reports from SDA, DPA, or AFP that are imported via BrixWire are classified as «Agency». All texts from the Reach area that are not based on agencies are assigned the category «Reach».",
    "metaform.placement.mainCategory": "Main category",
    "metaform.placement.mainCategory.placeholder": "Select main category...",
    "metaform.placement.tenantTitle": "Tenants",
    "metaform.placement.tenantTitle.tooltip": "The article is published to all selected tenants. The main tenant is important for search engine optimization, it has to be set.",
    "metaform.placement.title": "Placement",
    "metaform.pollSettings.label": "Voting on polls and ratings enabled",
    "metaform.pollSettings.title": "Polls and ratings",
    "metaform.pollSettings.tooltip": "As long as the toggle below is ON, users will be able to vote on all stars ratings and polls in this content. Once it's OFF, only results are displayed and voting no longer possible.",
    "metaform.printMetadata.category": "Category",
    "metaform.printMetadata.desknetEntry": "Kordiam entry",
    "metaform.printMetadata.desknetEntryLink": "Kordiam entry link",
    "metaform.printMetadata.desknetSync": "Enable sync to Kordiam",
    "metaform.printMetadata.desknetSyncDisabled": "Sync to Kordiam enabled",
    "metaform.printMetadata.desknetToolTip": "This button, once clicked, enables syncing this content to Kordiam. Once turned on, it cannot be turned off.",
    "metaform.printMetadata.desknetToolTipDisabled": "Syncing this content to Kordiam has been turned on. It cannot be turned off.",
    "metaform.printMetadata.pageName": "Page name",
    "metaform.printMetadata.publication": "Publication",
    "metaform.printMetadata.publicationTargetDate": "Publication target date",
    "metaform.printMetadata.studioDossierId": "Dossier ID",
    "metaform.printMetadata.studioDossierLink": "Dossier link",
    "metaform.printMetadata.studioStatus": "Print status",
    "metaform.printMetadata.studioSync": "Enable sync to WW Studio",
    "metaform.printMetadata.studioSyncDisabled": "Sync to WW Studio enabled",
    "metaform.printMetadata.studioToolTip": "This button, once clicked, enables syncing this content to WW Studio. Once turned on, it cannot be turned off.",
    "metaform.printMetadata.studioToolTipDisabled": "Syncing this content to WW Studio has been turned on. It cannot be turned off.",
    "metaform.printMetadata.targetDateTime": "Target date and time",
    "metaform.printMetadata.targetDateTime.tooltip": "The target date and the slot control the order in which articles are prioritised in the workflow. The time is determined by the online publication date in Kordiam.",
    "metaform.printMetadata.title": "Integration with print and planning",
    "metaform.printMetadata.type": "Type",
    "metaform.pushform.categories": "Categories",
    "metaform.pushform.message.title": "Message",
    "metaform.pushform.modal.confirm": "Confirm",
    "metaform.pushform.send": "Send",
    "metaform.pushform.send.confirmationMessage": "Are you sure you want to send this message?",
    "metaform.pushform.send.disabled": "Please make sure the content is published",
    "metaform.pushform.tenants": "Tenants",
    "metaform.pushform.title": "Push messages",
    "metaform.pushHistory.createdAt": "Sent to",
    "metaform.pushHistory.pushText": "Message",
    "metaform.pushHistory.refresh": "Refresh statuses",
    "metaform.pushHistory.title": "Message history",
    "metaform.scheduledPlacing.customUpdatedAtError": "The update time must be later than the publication time",
    "metaform.scheduledPlacing.error.required": "Publication time or expiry time is required",
    "metaform.scheduledPlacing.expiryTime": "Unpublish on",
    "metaform.scheduledPlacing.expiryTimeError": "Expiry time must be later than the publication time",
    "metaform.scheduledPlacing.on": "Scheduled publication",
    "metaform.scheduledPlacing.publicationTime": "Publish on",
    "metaform.scheduledPlacing.publishedOn": "Published on",
    "metaform.scheduledPlacing.targetDateRequired": "Target date is required",
    "metaform.scheduledPlacing.targetTextLength": "Target text length",
    "metaform.scheduledPlacing.targetTimeRequired": "Target time is required",
    "metaform.scheduledPlacing.targetUserNeed": "Target user need",
    "metaform.scheduledPlacing.title": "Planning",
    "metaform.scheduledPlacing.updatedNow": "Updated now",
    "metaform.scheduledPlacing.updatedOn": "Updated on",
    "metaform.seoTeaser.button.generate": "Generate SEO Teaser",
    "metaform.seoTeaser.button.generate.tooltip": "SEO Teaser cannot be generated for a blank article.",
    "metaform.seoTeaser.keywords.button.copy": "Copy From Default Teaser",
    "metaform.seoTeaser.keywords.button.error": "An error has occurred while generating keywords. Please try again.",
    "metaform.seoTeaser.keywords.button.generate": "Generate keywords and SEO Teaser",
    "metaform.seoTeaser.keywords.button.generate.tooltip": "Keywords cannot be generated for a blank article.",
    "metaform.seoTeaser.keywords.emptyKeyWords": "SEO Teaser is blank. Click here to fill its text. Or click the button to generate text and keywords. They will be generated automatically on reaching the target text length.",
    "metaform.seoTeaser.keywords.title": "Keywords suggestions",
    "metaform.seoTeaser.keywords.tooltip": "Not all keywords suggested by ChatGPT need to be used. Important: Place the most important keyword as early as possible. More information and tips in the <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>SEO Handbook.</linkComponent>",
    "metaform.seoTeaser.modal.lead.tooltip": "The SEO lead should not be longer than 140 characters and should start with the most important keywords. It must be edited before publication.",
    "metaform.seoTeaser.modal.title.tooltip": "The SEO title has to be unique, it should not be longer than 60 characters and must start with the most important keywords. It must be edited before publication.",
    "metaform.seoTeaser.title": "SEO Teaser",
    "metaform.specialTeaser.button.generate": "Generate Special Teaser",
    "metaform.specialTeaser.button.generate.tooltip": "Special Teaser cannot be generated for a blank article.",
    "metaform.style.title": "Style",
    "metaform.styles.backgroundstory": "Background story full width",
    "metaform.styles.backgroundstorywithads": "Background story",
    "metaform.styles.commentary": "Opinion teaser with an author image",
    "metaform.styles.default": "Default",
    "metaform.styles.focus": "Focus",
    "metaform.styles.fullwidth": "Full width",
    "metaform.styles.label": "Styles",
    "metaform.styles.newsbriefing": "Newsbriefing",
    "metaform.styles.notFoundContent": "Style not found",
    "metaform.styles.visual": "Visual",
    "metaform.tags.nonefound": "No more tags found",
    "metaform.tags.placeholder": "Select tags",
    "metaform.tags.title": "Tags",
    "metaform.tags.title.tooltip": "The news titles tag only municipalities and if necessary formats. Company tags are only used by «Finanz und Wirtschaft».",
    "metaform.teaser.abtest.betaFeature": "Only available to beta-testers at the moment.",
    "metaform.teaser.abtest.results.significance.notSignificant": "Not significant",
    "metaform.teaser.abtest.results.significance.significant": "Significant",
    "metaform.teaser.abtest.results.significance.tooltip": "The three possible values are: very significant (p-value below 0.01 or equal), significant (p between 0.01 and 0.05) and not significant (p greater than 0.05).",
    "metaform.teaser.abtest.results.significance.verySignificant": "Very significant",
    "metaform.teaser.abtest.status": "A/B test status",
    "metaform.teaser.abtest.status.completed": "Completed",
    "metaform.teaser.abtest.status.initialized": "Created",
    "metaform.teaser.abtest.status.running": "Started",
    "metaform.teaser.abtest.status.stopped": "Cancelled",
    "metaform.teaser.abtest.versionA": "Version A",
    "metaform.teaser.abtest.versionA.edit": "Edit teaser version A",
    "metaform.teaser.abtest.versionB": "Version B",
    "metaform.teaser.abtest.versionB.cancel": "Cancel A/B test",
    "metaform.teaser.abtest.versionB.cancel.confirm": "Are you sure to cancel the test? This will remove the version B and any results. You will be able to start a new test.",
    "metaform.teaser.abtest.versionB.create": "Create A/B test",
    "metaform.teaser.abtest.versionB.edit": "Edit teaser version B",
    "metaform.teaser.abtest.versionB.form.description": "In order to start the A/B test, update the B version here. The A version is already created based on the default teaser. The test will start once you save changes, publish the article and place in at least one category for which A/B tests are enabled. After 10 minutes the version with more clicks will be automatically set as new default teaser.",
    "metaform.teaser.abtest.versionB.remove": "Remove version B",
    "metaform.teaser.abtest.versionB.remove.confirm": "Are you sure to remove teaser version B? You will be able create another one.",
    "metaform.teaser.abtest.versionB.results.clicks": "Clicks",
    "metaform.teaser.abtest.versionB.seeResults": "See test results",
    "metaform.teaser.abtest.versionB.status.completed": "A/B test completed {{timestamp}}",
    "metaform.teaser.abtest.versionB.status.initialized": "The test will start once you save changes, publish the article and place it in at least one category for which A/B tests are enabled.",
    "metaform.teaser.abtest.versionB.status.running": "A/B test started {{timestamp}}. To update the teasers, cancel the test first. Only available to beta-testers at the moment.",
    "metaform.teaser.abtest.versionB.tooltip.disabled": "A/B test cannot be created if teaser variants exist or if the teaser is empty. Remove the variants or fill in the default teaser to create test. Only available to beta-testers at the moment.",
    "metaform.teaser.abtest.versionB.tooltip.testRunning": "Teaser variants cannot be created while A/B test is running",
    "metaform.teaser.allowAutomaticUpdate": "Automatically apply changes from content",
    "metaform.teaser.emptyDescription": "Image description is blank. Click on the teaser above to fill its text.",
    "metaform.teaser.imageDescription.size.error": "Teaser > Image description must be at most 1000 letters or symbols",
    "metaform.teaser.imageDescription.tooltip": "The alt text should precisely and concisely describe the image content, name identifiable people and places and contain relevant SEO keywords. Max. 150 characters. Example: Presidential candidate Kamala Harris speaks about Donald Trump at a campaign event in Detroit (USA). <spacer /> More information: <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/'>SEO-Handbook.</linkComponent> ",
    "metaform.teaser.modal": "Edit teaser",
    "metaform.teaser.modal.adoptdefaults": "Synchronize from default teaser",
    "metaform.teaser.modal.adoptdefaults.tooltip": "If teaser image is empty, it is always synchronised, and is not controlled by this toggle.",
    "metaform.teaser.modal.defaultTeaserRadio": "Default teaser",
    "metaform.teaser.modal.deleteimage": "Delete image",
    "metaform.teaser.modal.embeddedContentRadio": "Embedded content",
    "metaform.teaser.modal.embedUrl": "Embed URL",
    "metaform.teaser.modal.image": "Image",
    "metaform.teaser.modal.lead": "Lead",
    "metaform.teaser.modal.lead.tooltip": "The lead should not contain more than 180 characters.",
    "metaform.teaser.modal.preview.1:1": "Opener Mobile, Regular, Card (1:1)",
    "metaform.teaser.modal.preview.16:9": "Opener Desktop (16:9)",
    "metaform.teaser.modal.preview.2:1": "2:1",
    "metaform.teaser.modal.preview.3:2": "Panorama (3:2)",
    "metaform.teaser.modal.preview.animated": "This is an animated image and cannot be cropped",
    "metaform.teaser.modal.preview.title": "Teaser image previews:",
    "metaform.teaser.modal.refreshDescription": "Refresh image description",
    "metaform.teaser.modal.title": "Title",
    "metaform.teaser.modal.title.tooltip": "The title should not contain more than 80 characters.",
    "metaform.teaser.modal.titleHeader": "Title header",
    "metaform.teaser.modal.titleHeader.tooltip": "The title header should not contain more than 30 characters.",
    "metaform.teaser.modal.uploadimage": "Upload image",
    "metaform.teaser.special.tooltip": "This is the Open Graph (OG Title). The Open Graph is used for Social Media posts. This title is also displayed on Google Discover.. <spacer /> More information: <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1Sh6W2je2E6AMtUXLhNG86atksInlTNkGYdnMdWMnMlQ/edit#heading=h.2xre2ustyiqa'>SEO-Handbook.</linkComponent> ",
    "metaform.teaser.title": "Teaser",
    "metaform.teaser.type.default": "Default teaser",
    "metaform.teaser.type.opengraph": "Special teaser",
    "metaform.url.description": "Component of the URL that describes the content. Allowed characters are a-z, 0-9 and -.",
    "metaform.url.editButton": "Edit URL slug",
    "metaform.url.example": "Example: ",
    "metaform.url.title": "URL slug",
    "metaform.validation.modal.adjust.description": "To adjust this status or this publication schedule, the following fields need to be adapted:",
    "metaform.validation.modal.description": "In order to set this status or schedule publication, please adapt the following information:",
    "metaform.validation.modal.title": "Required fields",
    "metaform.validation.unpublishModal.description": "Are you sure that you want to unpublish this content?",
    "modal.cancelButton": "Cancel",
    "modal.cloneContent.title": "Clone content",
    "modal.confirmButton": "Ok",
    "modal.deleteButton": "Delete",
    "modal.deleteContent.message": "Are you sure you want to delete this element?",
    "modal.deleteContent.title": "Delete",
    "modal.duplicateContent.content": "Are you sure you want to duplicate this content?",
    "modal.duplicateContent.title": "Duplicate content",
    "navigation.articles": "Articles",
    "navigation.back": "Back",
    "navigation.breakingnews": "Breaking news",
    "navigation.categories": "Categories",
    "navigation.collections": "Collection",
    "navigation.curatedList": "Curated list",
    "navigation.embeds": "Embedded content",
    "navigation.geneeaEntities": "Geneea entities",
    "navigation.kickwords": "Kickwords",
    "navigation.links": "External links",
    "navigation.newsletters": "Newsletters",
    "navigation.placement": "Placement",
    "navigation.rtelements": "Components",
    "navigation.shortcuts": "Shortcuts",
    "navigation.sitemaps": "Sitemaps",
    "navigation.slideshows": "Slideshows",
    "navigation.tags": "Tags",
    "navigation.teams": "Teams & players",
    "navigation.tickers": "Livetickers",
    "navigation.users": "Accounts",
    "navigation.userSettings": "My account",
    "navigation.videos": "Videos",
    "newsletter.relatedcontent.modal.title": "Select content",
    "newsletters.edit": "Edit newsletter",
    "newsletters.hasConfig.title": "This newsletter is displayed on an article.",
    "newsletters.list.tab.active": "Active",
    "newsletters.list.tab.all": "All",
    "newsletters.list.tab.inactive": "Inactive",
    "newsletters.multipleSelected": "In case multiple newsletters are set to be shown on a given  category, one of them will be selected randomly.",
    "newsletters.showCta": "Show newsletter CTA on this article’s teaser",
    "newsletters.showSubscriptionsFromCategories": "Show newsletter subscription on articles from these categories",
    "newVersion": "A new Unity version {{newVersion}} was deployed. Please save first and <reloadLink>reload your browser window</reloadLink> !",
    "overviewList.actions.cloneArticleContent": "Clone content",
    "overviewList.actions.copyMetadataId": "Copy ID",
    "overviewList.actions.copyTextForAuthorisation": "Copy text for authorisation",
    "overviewList.actions.delete": "Delete",
    "overviewList.actions.duplicate": "Duplicate",
    "overviewList.author": "Author",
    "overviewList.characters": "Characters",
    "overviewList.contentStatus": "Content status",
    "overviewList.createdAt": "Created",
    "overviewList.createdBy": "Creator",
    "overviewList.endTime": "Completed",
    "overviewList.image": "Teaser image",
    "overviewList.itemsOnTheList": "{{totalElements}} items on the list",
    "overviewList.printDate": "Print date",
    "overviewList.publicationStatus": "Publication status",
    "overviewList.refreshedSecondsAgo": "Refreshed {{seconds}} second(s) ago",
    "overviewList.results": "Results",
    "overviewList.significance": "Significance",
    "overviewList.startTime": "Started",
    "overviewList.status": "Status",
    "overviewList.targetTime": "Target time",
    "overviewList.teaserImageA": "Image A",
    "overviewList.teaserImageB": "Image B",
    "overviewList.titleHeaderAndTitle": "Title header and title",
    "overviewList.titleHeaderAndTitleA": "Title header and title A",
    "overviewList.titleHeaderAndTitleB": "Title header and title B",
    "overviewList.updatedAt": "Updated",
    "overviewList.users": "Used by",
    "page.navigation.detail": "Content",
    "page.navigation.metadata": "Publication",
    "page.navigation.pushmessages": "Push",
    "page.setupForm.submitButton": "Create",
    "page.setupForm.title": "Setup",
    "page.title.articles": "Articles",
    "page.title.breakingnews": "Breaking news",
    "page.title.categories": "Categories",
    "page.title.collections": "Collection",
    "page.title.curatedList": "Curated list",
    "page.title.externalContent.embeds": "Embedded content",
    "page.title.externalContent.links": "External links",
    "page.title.externalContent.videos": "Video",
    "page.title.home": "Home",
    "page.title.kickwords": "Kickwords",
    "page.title.placement": "Placement",
    "page.title.rtelements": "Components",
    "page.title.sitemaps": "Sitemaps",
    "page.title.slideshows": "Slideshows",
    "page.title.tags": "Tags",
    "page.title.teams": "Teams & players",
    "page.title.tickers": "Liveticker",
    "page.title.users": "Accounts",
    "page.title.userSettings": "My account",
    "placement.columnheader.modal.config.allowAbTest": "A/B tests are enabled on this page.",
    "placement.drop.modal.move.confirm": "Move",
    "placement.drop.modal.replace.confirm": "Replace",
    "placement.dropFromPinned.modal.description": "<paragraph>The content <component>\"{{contentTitle}}\"</component> will be moved.</paragraph>",
    "placement.dropFromPinned.modal.title": "Move pinned content?",
    "placement.dropFromPlaceholder.modal.description": "<paragraph>The <component>{{categoryName}}</component> placeholder will be moved.</paragraph>",
    "placement.dropFromPlaceholder.modal.title": "Move placeholder content?",
    "placement.dropOnPinned.modal.description": "<paragraph>The content <component>\"{{contentTitle}}\"</component> will be replaced.</paragraph>",
    "placement.dropOnPinned.modal.title": "Replace pinned content?",
    "placement.dropOnPlaceholder.modal.description": "<paragraph>The <component>{{categoryName}}</component> placeholder will be replaced.</paragraph>",
    "placement.dropOnPlaceholder.modal.title": "Replace placeholder content?",
    "placement.premiumContentBadge": "Abo",
    "placement.premiumContentBadge.tooltip": "Premium content",
    "placement.section.copy.DEFAULT_SECTION_CANNOT_BE_COPIED.error": "Default sections cannot be copied.",
    "placement.section.copy.REMOVED_BUTTON.warning": "The category set for this section’s button is not present in {{tenantName}}'s sitemap. The button has been switched off in the section copy.",
    "placement.section.copy.REMOVED_CONTENT.warning": "At least one of the contents in the dropped section misses {{tenantName}}. The section was copied without them. Please add the tenant first in the content’s publication data and then drag&drop them manually.",
    "placement.section.copy.REMOVED_PLACEHOLDERS.warning": "The placeholder in the section references the same category as the target page or not present in {{tenantName}}'s sitemap. The placeholder has been removed from the copy.",
    "placement.section.copy.SECTION_CANNOT_BE_COPIED_TO_ITS_REFERENCED_PAGE.error": "The category set in this section is the same as in the target page. In such case copying is not possible.",
    "placement.section.copy.SECTION_CATEGORY_IS_MISSING_IN_THE_TARGET_SITEMAP.error": "The category set in this section is not present in {{tenantName}}'s sitemap. Please add a node for this category first and then drag&drop the section again.",
    "placementHistory.chart.now": "Now",
    "placementHistory.chart.positionInCategory": "Position in category",
    "placementHistory.chart.positionInSection": "Position in section",
    "placementHistory.chart.time": "Time",
    "placementHistory.chart.title": "Placement history chart",
    "placementHistory.closeButton.title": "Close",
    "placementHistory.title": "Placement history",
    "placementHistory.toolbar.dateRange.clear": "Clear",
    "placementHistory.toolbar.tenant": "Tenant",
    "placementtool.column.by": "by",
    "placementtool.column.category.placeholder": "Category",
    "placementtool.column.createButton": "Create column",
    "placementtool.column.drop.error.addTenantFirst": "Please add the tenant \"{{ tenantName }}\" first in the content's publication data",
    "placementtool.column.fullDatePrefix": "on",
    "placementtool.column.lastPublished": "Default last published",
    "placementtool.column.pageType.category.label": "Category",
    "placementtool.column.pageType.label": "Page type",
    "placementtool.column.pageType.tag.label": "Tag",
    "placementtool.column.tag.placeholder": "Tag",
    "placementtool.column.toolbar.section.create": "Create section",
    "placementtool.column.toolbar.submitButton": "publish",
    "placementtool.columnheader.closeButton.tooltip": "Close",
    "placementtool.columnheader.config.title": "Configuration",
    "placementtool.columnheader.modal.notPublished": "Not published!",
    "placementtool.columnheader.modal.notPublished.continue": "The changes are not published! Continue anyway?",
    "placementtool.columnheader.tenant": "Tenant",
    "placementtool.contentItem.deleted": "deleted",
    "placementtool.contentItem.notPublishedYet": "Not published yet",
    "placementtool.contentItem.unpublished": "unpublished",
    "placementtool.drop.hint": "Drop item here",
    "placementtool.history": "History",
    "placementtool.history.by": "by",
    "placementtool.history.modal.message": "Confirming will overwrite the current work in progress. This can NOT be undone. It has still to be published.",
    "placementtool.history.modal.title": "Attention",
    "placementtool.metadatalist.articles.title": "All articles",
    "placementtool.metadatalist.bookmarks.title": "Bookmarks",
    "placementtool.placeholderModal.title.create": "Create placeholder",
    "placementtool.placeholderModal.title.edit": "Edit placeholder",
    "placementtool.section.content_block": "Rich text",
    "placementtool.section.external_widget": "Recommender",
    "placementtool.section.no_logic": "No logic",
    "placementtool.section.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionForm.adPositionsSection.title": "Ad positions",
    "placementtool.sectionForm.adsPositions.desktop": "Desktop web",
    "placementtool.sectionForm.appearanceSection.title": "Appearance",
    "placementtool.sectionForm.backgroundColor": "Background Color",
    "placementtool.sectionForm.backgroundColor.blue": "Blue",
    "placementtool.sectionForm.backgroundColor.brown": "Brown",
    "placementtool.sectionForm.backgroundColor.green": "Green",
    "placementtool.sectionForm.backgroundColor.mint": "Mint",
    "placementtool.sectionForm.backgroundColor.neutral": "Neutral",
    "placementtool.sectionForm.backgroundColor.none": "None",
    "placementtool.sectionForm.backgroundColor.orange": "Orange",
    "placementtool.sectionForm.backgroundColor.pink": "Pink",
    "placementtool.sectionForm.backgroundColor.purple": "Purple",
    "placementtool.sectionForm.backgroundColor.tenantColor": "Tenant Color",
    "placementtool.sectionForm.buttonLink.categoryLink.label": "Category",
    "placementtool.sectionForm.buttonLink.internalLink.label": "Internal link",
    "placementtool.sectionForm.buttonLink.label": "Button link",
    "placementtool.sectionForm.buttonLink.link.label": "External link",
    "placementtool.sectionForm.buttonLink.tagLink.label": "Tag",
    "placementtool.sectionForm.buttonSection.title": "Button",
    "placementtool.sectionForm.buttonTextField.label": "Button text",
    "placementtool.sectionForm.categories.label": "Category reference",
    "placementtool.sectionForm.categoryToBeLinkedTo.label": "Category to be linked to",
    "placementtool.sectionForm.content.label": "Content",
    "placementtool.sectionForm.customTypeIdentifier.label": "Identifier",
    "placementtool.sectionForm.defaultCategory.label": "Default category",
    "placementtool.sectionForm.freshPin.label": "Fresh pin",
    "placementtool.sectionForm.isButtonVisible.label": "Show button",
    "placementtool.sectionForm.isInfiniteScroll.label": "Infinite scroll",
    "placementtool.sectionForm.isSectionVisible.label": "Show section",
    "placementtool.sectionForm.layouts.default": "Default",
    "placementtool.sectionForm.layouts.label": "Template",
    "placementtool.sectionForm.layouts.newfront_bundle": "Bundle",
    "placementtool.sectionForm.layouts.newfront_highlight": "Highlight",
    "placementtool.sectionForm.layouts.newfront_horizontal-scroll": "Horizontal Scroll",
    "placementtool.sectionForm.layouts.newfront_horizontal-stacked": "Horizontal Stacked",
    "placementtool.sectionForm.layouts.newfront_latest-news": "Latest news",
    "placementtool.sectionForm.layouts.newfront_list": "List",
    "placementtool.sectionForm.layouts.newfront_micro": "Micro",
    "placementtool.sectionForm.layouts.newfront_newsbriefing": "News Briefing",
    "placementtool.sectionForm.layouts.newfront_opener-list": "Opener List",
    "placementtool.sectionForm.layouts.newfront_opener-overview": "Opener Overview",
    "placementtool.sectionForm.layouts.newfront_opener-top": "Opener Top",
    "placementtool.sectionForm.layouts.newfront_panorama": "Panorama",
    "placementtool.sectionForm.layouts.newfront_standard-even": "Standard Even",
    "placementtool.sectionForm.layouts.newfront_standard-uneven": "Standard Uneven",
    "placementtool.sectionForm.navigationLayout.dropdown": "Dropdown Layout",
    "placementtool.sectionForm.navigationLayout.link": "Link Layout",
    "placementtool.sectionForm.recommenderSection.title": "Recommendation engine",
    "placementtool.sectionForm.searchText.label": "Search text",
    "placementtool.sectionForm.selectableCategories.label": "Selectable categories",
    "placementtool.sectionForm.showTitle.label": "Show title",
    "placementtool.sectionForm.subtitle.label": "Subtitle",
    "placementtool.sectionForm.tag.label": "Tag reference",
    "placementtool.sectionForm.tagToBeLinkedTo.label": "Tag to be linked to",
    "placementtool.sectionForm.teaserCount.label": "Number of contents",
    "placementtool.sectionForm.url.label": "Link URL",
    "placementtool.sectionForm.weightMomentum.label": "Momentum weight",
    "placementtool.sectionForm.weightPerformance.label": "Performance weight",
    "placementtool.sectionForm.weightRecency.label": "Recency weight",
    "placementtool.sectionForm.weightSemantic.label": "Semantic weight",
    "placementtool.sectionForm.widgetId.label": "Widget ID",
    "placementtool.sectionModal.add.title": "Add section",
    "placementtool.sectionModal.closeButton.tooltip": "Close",
    "placementtool.sectionModal.edit.title": "Edit section",
    "placementtool.sectionModal.form.submitButton": "Save",
    "placementtool.sectionModal.titleField.label": "Title",
    "placementtool.sectionModal.type.category": "Category",
    "placementtool.sectionModal.type.category.new": "Always show the first content in the category…",
    "placementtool.sectionModal.type.content_block": "Rich text",
    "placementtool.sectionModal.type.custom": "Custom",
    "placementtool.sectionModal.type.default": "Default",
    "placementtool.sectionModal.type.external_widget": "Recommender",
    "placementtool.sectionModal.type.label": "Type",
    "placementtool.sectionModal.type.no_logic": "No logic",
    "placementtool.sectionModal.type.ta-placement-engine": "TGD Recommender",
    "placementtool.sectionModal.type.tag": "Tag",
    "placementtool.sectionModal.type.user_category_selection": "Multiple categories",
    "placementtool.sectionpresets.add.button": "Save this view",
    "placementtool.sectionpresets.input.placeholder": "Enter label",
    "placementtool.sections.collapseAll": "Collapse all",
    "placementtool.sections.expandAll": "Expand all",
    "preview.error.metadata": "Could not find content metadata.",
    "preview.error.notAvailable": "Preview is not available",
    "preview.input.error.max.height": "Maximum height: {{maxSize}}",
    "preview.input.error.max.width": "Maximum width: {{maxSize}}",
    "preview.input.error.min.height": "Minimum height: {{minSize}}",
    "preview.input.error.min.width": "Minimum width: {{minSize}}",
    "preview.pageHeader.title": "Preview",
    "preview.pageHeader.tooltip": "The preview doesn't show the latest changes? Changes might take a few moments to show in the preview. Please make sure to save all changes before clicking the preview-button, otherwise they will not be visible. A refresh of the preview page can be forced with ctrl+shift+R / cmd+shift+R. If the article is created for more than one tenant, the tenant can be changed in the dropdown. This helps to refresh the preview.",
    "publicationStatus": "Publication status",
    "publicationStatus.internalOnly": "Internal AI only",
    "publicationStatus.internalOnly.tooltip": "Not public, not in Google, but can be used by internal AI-powered tools.",
    "publicationStatus.notPublished": "Not published",
    "publicationStatus.notPublished.tooltip": "Not public, not indexed, no AI usage.",
    "publicationStatus.published": "Published",
    "publicationStatus.published.tooltip": "Public, indexed and accessible to internal AI.",
    "publicationStatus.unlisted": "Not in Google",
    "publicationStatus.unlisted.tooltip": "Visible via direct link and websites, not indexed, internal AI allowed.",
    "publicationStatus.unpublished": "Deleted",
    "publicationStatus.unpublished.tooltip": "Fully removed and inaccessible.",
    "pushHistory.streamboat.noStatus": "No status available for Streamboat.",
    "pushStatus.description.externalError": "<p><strong>Temporarily failed</strong> to check status.</p>",
    "pushStatus.description.failed": "<p><strong>Failed</strong> sending message. No message has been sent to subscribers.</p>",
    "pushStatus.description.finished": "<p><strong>Finished</strong> sending message to subscribers.</p> <p>Sending took {{duration}} minutes.</p>",
    "pushStatus.description.sending": "<p><strong>Sending</strong> message to subscribers.</p> <p>Sending now for {{duration}} minutes.</p>",
    "pushStatus.description.unknown": "An unknown error has happened.",
    "pushStatus.externalError": "External error",
    "pushStatus.failed": "Failed",
    "pushStatus.finished": "Finished",
    "pushStatus.sending": "Sending",
    "pushStatus.unknown": "Unknown",
    "releaseNotes.btnCreate": "Create new",
    "releaseNotes.form.labelEdit": "Edit note",
    "releaseNotes.form.labelNew": "Add note",
    "releaseNotes.noContent": "No content",
    "releaseNotes.title": "Release note",
    "releaseNotes.visible": "Visible",
    "revision.currentTag": "Current revision",
    "revision.modal.confirmationMessage": "Are you sure you want to restore this revision?",
    "revision.modal.confirmButton": "Restore",
    "revision.modal.newRevisionMessage": "A new revision will be created based on it.",
    "revision.modal.title": "Restore revision",
    "revision.modal.unpublishMessage": "The article will be unpublished",
    "revision.restoreTag": "Will become a new revision when restored",
    "richtext.error.critical": "An error occurred while saving the field.",
    "richtext.warning.restore": "A problem with the editor has occurred. The latest known content has been restored.",
    "router.modal.content": "Changes are not saved.<br/>Do you really want to leave this site and continue without saving?",
    "router.modal.leave": "Yes, leave the page without saving",
    "router.modal.stay": "No, back",
    "router.modal.title": "Attention, Unity reports:",
    "rtElement.form.infobox.name": "Name",
    "rtElement.form.infobox.tenants": "Tenants",
    "rtElement.form.title.create": "Create component",
    "rtElement.form.title.edit": "Edit",
    "rtElement.name": "Name",
    "rtElement.tenants": "Tenants",
    "rtElements.list.addButton": "Create component",
    "rtElements.list.title": "Components",
    "rtElements.type.snippet": "Snippet",
    "scoreboard.resultAdditive.ot": "OT",
    "scoreboard.resultAdditive.so": "SO",
    "scoreboardForm.resultAdditive.label": "Final score addition",
    "scoreboardForm.resultAdditive.ot": "After overtime (OT)",
    "scoreboardForm.resultAdditive.so": "After shootout (SO)",
    "search.authors.label": "User/agency",
    "search.authors.nonefound": "No users/agencies found",
    "search.category.label": "Categories",
    "search.contentStatus.label": "Content statuses",
    "search.contentType.label": "Contents",
    "search.filterButton.less": "Less filters",
    "search.filterButton.more": "More filters",
    "search.filterButton.reset": "Reset filters",
    "search.leagues.iceHockey.label": "Leagues",
    "search.leagues.soccer.label": "Leagues",
    "search.leagues.tennis.label": "Modes",
    "search.main.label": "Search",
    "search.minCharacters": "Please enter at least 2 characters",
    "search.publicationStatus.label": "Publication statuses",
    "search.publishedAfter.label": "Published from",
    "search.publishedBefore.label": "Published until",
    "search.tab.keyword": "Keyword search",
    "search.tab.semantic": "Semantic search",
    "search.tags.label": "Tags",
    "search.tenants.label": "Tenants",
    "semanticSearch.loadMore": "Load more",
    "semanticSearch.slider.almostSame": "almost the same",
    "semanticSearch.slider.similar": "similar",
    "semanticSearch.slider.slightlySimilar": "slightly similar",
    "semanticSearch.slider.verySimilar": "very similar",
    "semanticSearch.tooltip": "Semantic search differs significantly from keyword search. Rather than checking for exact matches of letters and words, it can also find synonyms and related concepts. When searching for a word like \"fruit\", it will also find texts containing related terms like \"apple\" or \"pear\", It allows you to set the degree of similarity—that is, how closely the retrieved texts must match the search query thematically. You can also search using context or questions. <br/> <strong>For example</strong>: searching for articles about 'traffic problems in the municipality'. Semantic search doesn't just find texts with exactly these words, but also articles about 'congestion on the cantonal road,' 'parking shortage at the train station,' 'discussion about 30 km/h zones,' or 'problematic public transport connections'—all relevant content on the same topic, even though different terms were used.",
    "shortcuts.action.bold": "Bold",
    "shortcuts.action.cancel": "Cancel",
    "shortcuts.action.cycleRegion": "Cycle through page regions",
    "shortcuts.action.focusContentStatus": "Focus content status",
    "shortcuts.action.focusPublicationStatus": "Focus publication status",
    "shortcuts.action.insertMenuSwitchColumn": "Insert menu: switch column",
    "shortcuts.action.insertMenuSwitchTab": "Insert menu: switch tab",
    "shortcuts.action.italic": "Italic",
    "shortcuts.action.link": "Insert or edit link",
    "shortcuts.action.metadataHistory": "Open metadata history",
    "shortcuts.action.moveElementDown": "Move element down",
    "shortcuts.action.moveElementUp": "Move element up",
    "shortcuts.action.openComments": "Open comments",
    "shortcuts.action.openInsertMenu": "Open insert element menu",
    "shortcuts.action.openMetadataFromOverview": "Open metadata from overview",
    "shortcuts.action.openSpellChecker": "Open spellchecker",
    "shortcuts.action.orderedList": "Numbered list",
    "shortcuts.action.placementHistory": "Open placement history",
    "shortcuts.action.preview": "Open preview",
    "shortcuts.action.rephrase": "Rephrase paragraph",
    "shortcuts.action.save": "Save",
    "shortcuts.action.showShortcuts": "Show keyboard shortcuts",
    "shortcuts.action.subscript": "Subscript",
    "shortcuts.action.superscript": "Superscript",
    "shortcuts.action.switchTabContent": "Go to Content tab",
    "shortcuts.action.switchTabPublication": "Go to Publication tab",
    "shortcuts.action.switchTabPush": "Go to Push tab",
    "shortcuts.action.underline": "Underline",
    "shortcuts.action.unorderedList": "Bulleted list",
    "shortcuts.category.editor": "Editor",
    "shortcuts.category.navigation": "Navigation",
    "shortcuts.category.page": "Page actions",
    "shortcuts.dialog.closeButton.title": "Close",
    "shortcuts.dialog.title": "Shortcuts",
    "showmore.title.closed": "Show more",
    "showmore.title.open": "Show less",
    "sitemap.edit.defaultTitle": "Add node",
    "sitemap.edit.title": "Edit node",
    "sitemap.fixedmenubar.restore": "Restore",
    "sitemap.fixedmenubar.save": "Save changes",
    "sitemap.form.allowRobots": "Show in search engines",
    "sitemap.form.availableFor": "Available for",
    "sitemap.form.availableFor.app": "App",
    "sitemap.form.availableFor.desktop": "Desktop",
    "sitemap.form.categoryReference": "Category reference",
    "sitemap.form.categoryUrlPath": "URL slug",
    "sitemap.form.clientPageIdentifier": "Identifier",
    "sitemap.form.clientPagePath": "Path",
    "sitemap.form.contentLink": "External URL",
    "sitemap.form.contentReference": "Content reference",
    "sitemap.form.contentUrlSlug": "URL slug",
    "sitemap.form.contentUrlSlug.description": "This will overwrite the URL slug of the selected content.",
    "sitemap.form.icon": "Icon",
    "sitemap.form.indexing": "Indexing",
    "sitemap.form.metaDescription": "Meta description",
    "sitemap.form.metaTitle": "Meta title",
    "sitemap.form.modal.deleteMessage": "If this sitemap element is deleted and contains children, they will also be deleted. This also applies to the menu nodes.",
    "sitemap.form.name": "Display name",
    "sitemap.form.newWindow": "Open in new window",
    "sitemap.form.nodeType": "Node type",
    "sitemap.form.notFoundContent": "Category not found",
    "sitemap.form.pageStyle.caption": "Page style",
    "sitemap.form.pageStyle.dasMagazin": "Das Magazin",
    "sitemap.form.pageStyle.default": "Default",
    "sitemap.form.pageStyle.video": "Video",
    "sitemap.form.pageStyle.zueriTipp": "Züritipp",
    "sitemap.form.subtitle": "Subtitle",
    "sitemap.form.tagReference": "Tag reference",
    "sitemap.form.tagUrlSlug": "URL slug",
    "sitemap.form.tagUrlSlug.description": "Component of the URL that describes the content. Allowed characters are a-z, 0-9 and -. It is always preceded by the identifier \"tags/\". Example: …/tags/your-tag-name-here",
    "sitemap.form.type.category": "Category",
    "sitemap.form.type.clientPage": "Static page",
    "sitemap.form.type.content": "Content",
    "sitemap.form.type.external": "External link",
    "sitemap.form.type.group": "Node group",
    "sitemap.form.type.tag": "Tag",
    "sitemap.list.addButton": "Add node",
    "sitemap.list.placeholder.name": "(New node)",
    "sitemap.menu.cancelButton": "Restore",
    "sitemap.menu.highlighted": "Highlighted",
    "sitemap.menu.labels.footer": "Footer",
    "sitemap.menu.labels.menu": "Menu",
    "sitemap.menu.labels.menuFooter": "Menu footer",
    "sitemap.menu.labels.topNavigation": "Top navigation",
    "sitemap.menu.labels.userPanel": "User panel",
    "sitemap.menu.modal.deleteButton": "Remove node",
    "sitemap.menu.modal.submitButton": "Apply",
    "sitemap.menu.modal.title": "Edit menu node",
    "sitemap.menu.placeholder": "Select menu",
    "sitemap.menu.submitButton": "Save changes",
    "sitemap.menu.title": "Menus",
    "sitemap.tenantSelector.placeholder": "Tenant",
    "slidelist.validation.message": "There are slides with missing informations",
    "slideshow.bulkSlideForm.title": "Edit all slides",
    "slideshow.detail.editButton": "Edit slideshow details",
    "slideshow.detail.title": "Slideshow details",
    "slideshow.editorPlugin.preview.noSlideLink": "Edit slideshow",
    "slideshow.editorPlugin.preview.noSlideMessage": "There is no slide in this slideshow.",
    "slideshow.form.lead": "Lead",
    "slideshow.form.title": "Title",
    "slideshow.form.titleHeader": "Title header",
    "slideshow.list.createButton": "Create slideshow",
    "slideshow.navigation.next": "Next",
    "slideshow.navigation.previous": "Previous",
    "slideshow.router.modal.content": "Descriptions are not yet generated for all the slides. If you leave now, they will remain blank. <br/> Do you really want to leave this site and continue without saving?",
    "slideshow.setup.pageTitle": "New slideshow",
    "slideshow.slideform.invalidTooltip": "To set the teaser, all slides must be error-free.",
    "slideshow.slideform.setImage": "Set image as teaser image",
    "slideshow.slideform.title": "Edit slide",
    "slideshow.slideform.visible": "Visible",
    "slideshow.slidelist.addButton": "Create slide",
    "slideshow.slidelist.editAll": "Edit all",
    "slideshow.slidelist.restore": "Restore",
    "slideshow.slidelist.save": "Save order",
    "slideshow.slidelist.saveOrder": "Save the order first",
    "slideshow.slidelist.title": "Slides ({{quantity}})",
    "spellchecker.error.overload.message": "The Spellchecker is currently overloaded. Please try again later.",
    "spellchecker.error.timeout.message": "The Spellchecker took more time than usual and failed. Please try again.",
    "statusSelect.disabled.tooltip": "To change the status, please save first",
    "tag.description": "Description",
    "tag.edit.title": "Edit tag",
    "tag.form.active": "Active",
    "tag.form.allowRobots": "Show in search engines",
    "tag.form.asyncvalidate.reject": "This name is already taken",
    "tag.form.description": "Description",
    "tag.form.geneeaEntity.hint": "Articles marked with this entity automatically appear on this tag’s page. If you don’t want this to happen, remove the entity above and save changes.",
    "tag.form.geneeaEntity.label": "Assigned entity",
    "tag.form.image": "Image",
    "tag.form.name": "Name",
    "tag.form.title": "Title",
    "tag.list.addButton": "Create tag",
    "tag.list.tab.active": "Active",
    "tag.list.tab.all": "All",
    "tag.name": "Name",
    "tag.setup.title": "Create tag",
    "tag.title": "Title",
    "team.edit.title": "Edit team",
    "team.form.image": "Image",
    "team.form.image.edit": "Edit image",
    "team.form.leagues": "Leagues",
    "team.form.leagues.placeholder": "Select leagues...",
    "team.form.name": "Name",
    "team.form.noResults": "No results found",
    "team.header.select.iceHockeyTeams": "Ice hockey teams",
    "team.header.select.leaguesAndTournaments": "Leagues and tournaments",
    "team.header.select.soccerTeams": "Soccer teams",
    "team.header.select.tennisPlayers": "Tennis players",
    "team.route.iceHockeyTeams.create.label": "Add team",
    "team.route.leaguesAndTournaments.create.label": "league or tournament",
    "team.route.soccerTeams.create.label": "Add team",
    "team.route.tennisPlayers.create.label": "Add player(s)",
    "team.setup.title": "Create team",
    "team.type.select": "Teams, players, leagues and tournaments...",
    "teaser.form.submitButton": "Ok",
    "tenantchooser.editButton": "Edit tenants",
    "tenantchooser.mainTenant": "Main tenant",
    "tenantchooser.mainTenant.placeholder": "Select main tenant",
    "tenantchooser.modal.title": "Selected tenants",
    "tenantgroup.checkbox.bern": "Bern",
    "tenantgroup.checkbox.régionaux": "Regionals",
    "tenantgroup.checkbox.tamediaNews": "Tamedia news",
    "tenantgroup.checkbox.zürich": "Zurich",
    "tenants.selection.submitButton": "Apply",
    "tenantspecific.copy.button": "Apply",
    "tenantSpecific.copy.label": "Copy values to:",
    "tenantSpecific.copy.placeholder": "Select tenants",
    "tenantspecific.error": "Incorrect values found",
    "tenantspecific.variantButton": "Variants",
    "tennis.edit.title": "Edit player / double",
    "tennis.form.name": "Name of player / double",
    "tennis.form.radio.title.mode": "Mode",
    "tennis.setup.title": "Create player / double",
    "ticker.content.editButton": "Edit",
    "ticker.content.editPost": "Edit post",
    "ticker.content.newPost": "New post",
    "ticker.event.athletics": "Athletics",
    "ticker.event.basketball": "Basketball",
    "ticker.event.beachVolleyball": "Beach-volleyball",
    "ticker.event.card": "Card",
    "ticker.event.crossCountrySkiing": "Cross-country skiing",
    "ticker.event.curling": "Curling",
    "ticker.event.cycling": "Cycling",
    "ticker.event.equestrianism": "Equestrianism",
    "ticker.event.fencing": "Fencing",
    "ticker.event.figureSkating": "Figure skating",
    "ticker.event.formula1": "Formula 1",
    "ticker.event.freeText": "Other",
    "ticker.event.game": "Game",
    "ticker.event.gameEnd": "Game end",
    "ticker.event.gameMinute": "Game minute",
    "ticker.event.gameStart": "Game start",
    "ticker.event.goal": "Goal",
    "ticker.event.golf": "Golf",
    "ticker.event.halftimeEnd": "Halftime end",
    "ticker.event.halftimeStart": "Halftime start",
    "ticker.event.horseRiding": "Horse riding",
    "ticker.event.iceHockey": "Ice hockey",
    "ticker.event.info": "Info",
    "ticker.event.match": "Match",
    "ticker.event.miss": "Miss",
    "ticker.event.overtimeEnd": "Overtime end",
    "ticker.event.overtimeStart": "Overtime start",
    "ticker.event.penalty": "Penalty",
    "ticker.event.periodEnd": "Period end",
    "ticker.event.periodStart": "Period start",
    "ticker.event.point": "Point",
    "ticker.event.set": "Set",
    "ticker.event.shootOut": "Shoot-out",
    "ticker.event.shootOutEnd": "Shoot-out end",
    "ticker.event.shootOutStart": "Shoot-out start",
    "ticker.event.skiing": "Skiing",
    "ticker.event.snowboarding": "Snowboarding",
    "ticker.event.soccer": "Soccer",
    "ticker.event.substitution": "Substitution",
    "ticker.event.swimming": "Swimming",
    "ticker.event.team1": "Team 1",
    "ticker.event.team2": "Team 2",
    "ticker.event.tennis": "Tennis",
    "ticker.event.tiebreak": "Tiebreak",
    "ticker.event.timeEvent": "Time event",
    "ticker.event.timeout": "Timeout",
    "ticker.event.volleyball": "Volleyball",
    "ticker.eventform.compact.eventType.placeholder": "Select a sport...",
    "ticker.eventform.date": "Date",
    "ticker.eventform.dateTime": "Time",
    "ticker.eventform.displayTime": "Display time",
    "ticker.eventform.error": "Either set to invisible or post message has to be filled out",
    "ticker.eventform.eventType.label": "Type",
    "ticker.eventform.keyEvent": "Key event",
    "ticker.eventform.keyEvent.title.required": "If the \"Key event\" box is checked, the post title cannot be blank.",
    "ticker.eventform.message": "Message",
    "ticker.eventform.title": "Title",
    "ticker.eventform.visible": "Visible",
    "ticker.eventlist.teaser": "Teaser",
    "ticker.eventlist.teaserform.applyteaser": "Apply changes to teaser",
    "ticker.eventlist.teaserform.intro": "Intro",
    "ticker.eventlist.teaserform.lead": "Lead",
    "ticker.eventlist.teaserform.title": "Title",
    "ticker.eventlist.teaserform.titleHeader": "Title header",
    "ticker.list.createButton": "Create ticker",
    "ticker.list.pageTitle": "Livetickers",
    "ticker.setup.league.league": "League",
    "ticker.setup.league.mode": "Mode",
    "ticker.setup.noTeamFound": "No team found",
    "ticker.setup.pageTitle": "New liveticker",
    "ticker.setup.scoreboardEnabled": "Display default scoreboard",
    "ticker.setup.teamSelector.player": "Player",
    "ticker.setup.teamSelector.team": "Team",
    "ticker.setup.tickerType": "Liveticker type",
    "ticker.soccer.card.red": "Red",
    "ticker.soccer.card.yellow": "Yellow",
    "ticker.soccer.redCard": "Red card",
    "ticker.soccer.yellowCard": "Yellow card",
    "ticker.tennis.break": "Break",
    "ticker.tennis.breakball": "Breakball",
    "ticker.tennis.matchball": "Match point",
    "ticker.tennis.mini-break": "Mini-Break",
    "ticker.tennis.scoreboard.match.finished": "Match is finished",
    "ticker.tennis.scoreboard.serveFirst": "Serve first",
    "ticker.tennis.set": "Set",
    "ticker.tennis.setball": "Set point",
    "ticker.type.iceHockey": "Ice hockey",
    "ticker.type.soccer": "Soccer",
    "ticker.type.sportsCompact": "Sports summary",
    "ticker.type.standard": "Standard",
    "ticker.type.tennis": "Tennis",
    "toolbar.articleBuddy.approve": "Apply",
    "toolbar.articleBuddy.backButton.title": "New review",
    "toolbar.articleBuddy.category.balancedReporting.description": "Identifies selective omissions or distortions that skew the overall picture. Checks whether relevant facts are missing or context has been manipulated to support a particular narrative.",
    "toolbar.articleBuddy.category.balancedReporting.label": "Balanced Reporting",
    "toolbar.articleBuddy.category.chartPotential.description": "Flags passages that a Datawrapper chart or map would make clearer. To do this, it analyses the article for chart-ready content and prepares the relevant figures so you can load them directly into the Datawrapper Helper. Any missing data it pulls from reliable public sources with citations.",
    "toolbar.articleBuddy.category.chartPotential.label": "Chart potential",
    "toolbar.articleBuddy.category.clarity.description": "Flags unexplained jargon, abbreviations, or missing context. Ensures accessibility for a general audience.",
    "toolbar.articleBuddy.category.clarity.label": "Clarity",
    "toolbar.articleBuddy.category.contextAndAccuracy.description": "Evaluates whether claims are backed by sources and provide sufficient context for understanding. Checks for missing background information or sources and misleading representations.",
    "toolbar.articleBuddy.category.contextAndAccuracy.label": "Context & Accuracy",
    "toolbar.articleBuddy.category.erase.description": "Marks passages that can be removed entirely to shorten the text without losing essential meaning.",
    "toolbar.articleBuddy.category.erase.label": "Erase",
    "toolbar.articleBuddy.category.fairness.description": "Checks whether affected parties were given the right to reply and whether the presumption of innocence is respected. Criticism must be fairly framed, without personal attacks or defamation.",
    "toolbar.articleBuddy.category.fairness.label": "Fairness",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.description": "Checks for generic masculine forms. Recommends neutral alternatives while respecting named individuals.",
    "toolbar.articleBuddy.category.genderInclusiveLanguage.label": "Gender-Inclusive Language",
    "toolbar.articleBuddy.category.helvetisms.description": "Ensures consistent use of Swiss Standard German (or French). Replaces foreign variants with correct Swiss expressions.",
    "toolbar.articleBuddy.category.helvetisms.label": "Helvetisms",
    "toolbar.articleBuddy.category.independence.description": "Evaluates whether reporting is independent of PR influences. Checks for uncritical reproduction of press releases, promotional language, or one-sided presentation of commercial products without critical context.",
    "toolbar.articleBuddy.category.independence.label": "Independence",
    "toolbar.articleBuddy.category.languageStyle.description": "Checks for nominalizations, passive voice, filler words, clichés, and redundancies. Prefers active, concise phrasing with strong verbs.",
    "toolbar.articleBuddy.category.languageStyle.label": "Language & Style",
    "toolbar.articleBuddy.category.misspelledNames.description": "Flags person names that appear to be misspelled. Indicates what spelling is likely the correct one. To do this, the tool cross-checks each name via web search against authoritative sources (e.g., institutional websites or Linkedin), taking into account the context from the article.",
    "toolbar.articleBuddy.category.misspelledNames.label": "Misspelled names",
    "toolbar.articleBuddy.category.nonDiscrimination.description": "Checks whether nationality, ethnicity, religion, or sexual orientation are only mentioned when relevant to the story. Generalizations and stereotypes should be avoided.",
    "toolbar.articleBuddy.category.nonDiscrimination.label": "Non-discrimination",
    "toolbar.articleBuddy.category.opinionVsFact.description": "Checks whether opinions are clearly marked as such and not presented as facts.",
    "toolbar.articleBuddy.category.opinionVsFact.label": "Opinion vs Fact",
    "toolbar.articleBuddy.category.paraphrase.description": "Suggests tighter wording or rephrasing that preserves meaning while reducing character count.",
    "toolbar.articleBuddy.category.paraphrase.label": "Paraphrase",
    "toolbar.articleBuddy.category.pluralism.description": "Evaluates whether different perspectives are represented, especially on controversial topics. Checks for one-sided reporting or lack of diversity in voices and viewpoints.",
    "toolbar.articleBuddy.category.pluralism.label": "Pluralism",
    "toolbar.articleBuddy.category.privacy.description": "Evaluates the handling of sensitive information and private details. Checks whether human dignity is preserved and privacy is respected.",
    "toolbar.articleBuddy.category.privacy.label": "Privacy",
    "toolbar.articleBuddy.category.punctuation.description": "Checks correct use of colons, dashes, and other punctuation marks. Flags overuse or misuse.",
    "toolbar.articleBuddy.category.punctuation.label": "Punctuation",
    "toolbar.articleBuddy.category.quotations.description": "Evaluates whether quotes add value (opinion, emotion, originality). Flags empty or redundant quotes that should be paraphrased or cut.",
    "toolbar.articleBuddy.category.quotations.label": "Quotations",
    "toolbar.articleBuddy.category.sentenceStructure.description": "Identifies overly long or nested sentences. Recommends breaking them into clear, readable units.",
    "toolbar.articleBuddy.category.sentenceStructure.label": "Sentence Structure",
    "toolbar.articleBuddy.category.sourceTransparency.description": "Checks whether sources are made transparent and potential conflicts of interest are disclosed. Anonymity must be editorially justified. Hidden lobbying connections or commercial interests must be identifiable.",
    "toolbar.articleBuddy.category.sourceTransparency.label": "Source Transparency",
    "toolbar.articleBuddy.category.structureNarrativeArc.description": "Evaluates lead strength, logical flow, transitions, and ending quality. Flags missing narrative thread or weak openings/closings.",
    "toolbar.articleBuddy.category.structureNarrativeArc.label": "Structure & Narrative Arc",
    "toolbar.articleBuddy.category.toneLanguageRegister.description": "Checks for inappropriate colloquialisms, bureaucratic jargon, or biased language. Ensures a neutral, professional tone.",
    "toolbar.articleBuddy.category.toneLanguageRegister.label": "Tone & Language Register",
    "toolbar.articleBuddy.categoryTeaser": "The check considers the following criteria. Only those criteria that indicate a need for further investigation are displayed.",
    "toolbar.articleBuddy.checklist": "Checklist",
    "toolbar.articleBuddy.dismiss": "Ignore",
    "toolbar.articleBuddy.error": "An error occurred while fetching the results, please try again later.",
    "toolbar.articleBuddy.feedback": "Got feedback on Article Buddy? Share your suggestions on Slack: <link />",
    "toolbar.articleBuddy.intro": "Select the desired checks and start the analysis. Depending on the text length, it can take up to four minutes.",
    "toolbar.articleBuddy.modal.confirmationMessage": "The current Article Buddy analysis will be discarded, <br /> any text adjustments made will be retained. <br /> You can then start a new analysis.",
    "toolbar.articleBuddy.modal.confirmationTitle": "End analysis?",
    "toolbar.articleBuddy.noResults": "No suggestions.",
    "toolbar.articleBuddy.reviewCriteriaModal.closeButton.title": "Close",
    "toolbar.articleBuddy.reviewCriteriaModal.title": "Review Criteria",
    "toolbar.articleBuddy.submitButton": "Review my article",
    "toolbar.articleBuddy.submitButton.tooltip": "There are unsaved changes or empty content. Please save the article before reviewing.",
    "toolbar.articleBuddy.summary": "Summary",
    "toolbar.articleBuddy.title": "Article Buddy",
    "toolbar.articleBuddy.types.graphic.description": "Identify passages that would benefit from a chart or map.",
    "toolbar.articleBuddy.types.graphic.label": "Graphic check",
    "toolbar.articleBuddy.types.nameChecker.description": "Check people's names via web search for correct spelling in the article.",
    "toolbar.articleBuddy.types.nameChecker.label": "Name Check",
    "toolbar.articleBuddy.types.shortening.description": "Intelligent text reduction of article character count according to target length.",
    "toolbar.articleBuddy.types.shortening.label": "Shortening Suggestions",
    "toolbar.articleBuddy.types.shortening.tooltip": "Shortening suggestions can only be provided if target length is not blank, not set to Special Length and not above the current article length. You can update it in the publication tab.",
    "toolbar.articleBuddy.types.standards.description": "Check article against editorial standards and guidelines.",
    "toolbar.articleBuddy.types.standards.label": "Standards",
    "toolbar.articleBuddy.types.style.description": "Review article for language, readability, structure, and tone.",
    "toolbar.articleBuddy.types.style.label": "Style",
    "toolbar.attachments.copyImageUrl": "Copy image URL",
    "toolbar.attachments.delete.modal.message": "Should this file really be deleted from attachments?",
    "toolbar.attachments.delete.modal.title": "Delete from attachments",
    "toolbar.attachments.deleteImage": "Delete image",
    "toolbar.attachments.mode.cards": "Show as cards",
    "toolbar.attachments.mode.list": "Show as list",
    "toolbar.attachments.status.unused": "Not used online",
    "toolbar.attachments.status.used": "Used online",
    "toolbar.attachments.title": "Attachments",
    "toolbar.attachments.zoomImage": "Zoom image",
    "toolbar.comments.commentsInText": "... comments in this text",
    "toolbar.comments.description1": "Comments can be added by highlighting a text passage and then submitting the text field that will be displayed.",
    "toolbar.comments.description2": "The comments can be displayed and hidden with the <kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>K</kbd> keyboard shortcut or by opening and closing the tool tab.",
    "toolbar.comments.title": "Comments",
    "toolbar.liquidContent.addFormat": "Add Format",
    "toolbar.liquidContent.articleFormat": "Article format",
    "toolbar.liquidContent.articleFormats": "Article formats",
    "toolbar.liquidContent.create": "Create liquid variants",
    "toolbar.liquidContent.create.button": "Create",
    "toolbar.liquidContent.create.description": "Please select the formats and tenants below. Once you click the green button, the additional articles will be created and their content rewritten by AI prompts, according to your choice.",
    "toolbar.liquidContent.error": "An error has occurred while generating the liquid variants. Please try again.",
    "toolbar.liquidContent.format": "Format",
    "toolbar.liquidContent.format.none": "None",
    "toolbar.liquidContent.format.qa": "Q&A",
    "toolbar.liquidContent.format.short": "Paraphrase",
    "toolbar.liquidContent.format.source": "Source article",
    "toolbar.liquidContent.tenants": "Tenants",
    "toolbar.liquidContent.title": "Liquid content",
    "toolbar.liquidContent.tooltip": "Another user has already started creation of liquid variants. Once they are ready, you will see them in this tab.",
    "toolbar.otherAiTools.description": "The tools linked below are already implemented in the Tamedia Toolbox but not yet in Unity. Clicking the link opens the Toolbox in a new tab and starts the generation. Important: The tools might still be in testing phase.",
    "toolbar.otherAiTools.title": "Other AI tools",
    "toolbar.otherAiTools.toolNames.datawrapperHelper": "To the Datawrapper Helper",
    "toolbar.otherAiTools.toolNames.printTeaser": "Create a print teaser",
    "toolbar.otherAiTools.toolNames.pushMessage": "Create a push message",
    "toolbar.otherAiTools.toolNames.translation": "Translate the article",
    "toolbar.revisions.by": "by",
    "toolbar.revisions.created": "Created",
    "toolbar.revisions.restore": "Restore",
    "toolbar.revisions.revision": "Revision",
    "toolbar.revisions.title": "Revisions",
    "toolbar.seoChecker.error": "An error has occurred",
    "toolbar.seoChecker.googleTrendsSuggestions": "Suggestions on Google Trends",
    "toolbar.seoChecker.grade.bad": "Bad",
    "toolbar.seoChecker.grade.fantastic": "Fantastic",
    "toolbar.seoChecker.grade.good": "Good",
    "toolbar.seoChecker.grade.okay": "Okay",
    "toolbar.seoChecker.grade.veryGood": "Very good",
    "toolbar.seoChecker.header": "SEO evaluation:",
    "toolbar.seoChecker.keywords": "The five main keywords for this text are:",
    "toolbar.seoChecker.keywordsMissing.shortArticle": "The SEO check cannot be carried out without keywords. They are generated automatically when the article text is 150 below its target length. If this is not the case, the keywords can be generated manually in the SEO Teaser card in the publication tab. To do this, click on the «Generate keywords» button.",
    "toolbar.seoChecker.keywordsMissing.specialLength": "As Special Length is set as target for this article, keywords are not generated for it automatically. To start the SEO check, the keywords can be generated manually in the SEO Teaser card in the publication tab. To do this, click on the «Generate keywords» button.",
    "toolbar.seoChecker.keywordsMissing.title": "Keywords are missing, please generate",
    "toolbar.seoChecker.title": "SEO Helper",
    "toolbar.spellChecker.congratulations": "Congratulations!",
    "toolbar.spellChecker.description1": "They are marked with the <red>red</red> (spelling), <green>green</green> (grammar), <blue>blue</blue> (typography) or <orange>orange</orange> (other) underlines in the editor.",
    "toolbar.spellChecker.description2": "They can be corrected by clicking on the underlined words in the editor and selecting an alternative or simply typing in the corrections needed.",
    "toolbar.spellChecker.description3": "The error marks can be displayed and hidden with the<pre> Ctrl + Shift + A </pre>keyboard shortcut or by opening and closing the tool tab.",
    "toolbar.spellChecker.error": "An error has occurred",
    "toolbar.spellChecker.errorsReported": "... errors reported for this text",
    "toolbar.spellChecker.evaluatingText": "The text is being evaluated",
    "toolbar.spellChecker.noErrors": "There are no errors in this content",
    "toolbar.spellChecker.title": "Spellchecker",
    "toolbar.spellChecker.wait": "Please wait",
    "toolbar.teaserGenerator.apply": "Apply suggestion",
    "toolbar.teaserGenerator.error": "An error has occurred",
    "toolbar.teaserGenerator.error.unknown": "An unknown error has happened.",
    "toolbar.teaserGenerator.fewerProposals": "Could not generate all {{numOfProposals}} proposals",
    "toolbar.teaserGenerator.intro": "Generate suggestions for three different teasers based on the current text of the article. Only suitable for agency or municipality announcements.",
    "toolbar.teaserGenerator.introBold": "The suggestion must be mandatorily checked for content and style. If you have questions, refer to #ai_lab_infos",
    "toolbar.teaserGenerator.proposal": "Proposed teaser",
    "toolbar.teaserGenerator.propose": "Propose teasers",
    "toolbar.teaserGenerator.proposeButton.tooltip": "Teaser suggestions cannot be generated for a blank article.",
    "toolbar.teaserGenerator.refresh": "Refresh suggestions",
    "toolbar.teaserGenerator.retry": "Retry",
    "toolbar.teaserGenerator.title": "Teaser suggestions",
    "toolbar.teaserGenerator.wait": "One moment",
    "toolbar.teaserGenerator.waitDescription": "Teasers are being generated",
    "toolbar.translation.directionToFrench": "German → French",
    "toolbar.translation.directionToGerman": "French → German",
    "toolbar.translation.emptyArticle": "The article has no text to translate.",
    "toolbar.translation.failed": "The translation failed.",
    "toolbar.translation.introToFrench": "The translation is created as a new article in the French version.",
    "toolbar.translation.introToGerman": "The translation is created as a new article in the German version.",
    "toolbar.translation.openArticle": "Open article",
    "toolbar.translation.pendingHint": "This can take a few minutes. You can keep working — the result will appear here.",
    "toolbar.translation.pendingIntoFrench": "Translating into French…",
    "toolbar.translation.pendingIntoGerman": "Translating into German…",
    "toolbar.translation.submit": "Translate",
    "toolbar.translation.success": "The article has been translated.",
    "toolbar.translation.title": "Translation",
    "toolbar.translation.translateAgain": "Translate again",
    "toolbar.translation.tryAgain": "Try again",
    "toolbar.translation.unsavedChanges": "The translation uses the last saved version — save your changes first.",
    "toolbar.userNeeds.depth": "Depth",
    "toolbar.userNeeds.depth.description": "Give me context and background",
    "toolbar.userNeeds.distract": "Distract",
    "toolbar.userNeeds.distract.description": "Entertain me",
    "toolbar.userNeeds.facts": "Facts",
    "toolbar.userNeeds.facts.description": "Give me the essential",
    "toolbar.userNeeds.inspiration": "Inspiration",
    "toolbar.userNeeds.inspiration.description": "Touch and inspire me",
    "toolbar.userNeeds.justification": "Justification",
    "toolbar.userNeeds.none.description": "No user need assigned yet. It will start automatically when the the article text is 150 below its target length or manually when you click the button below.",
    "toolbar.userNeeds.none.name": "None",
    "toolbar.userNeeds.none.targetDescription": "No target user need set yet. You can set it in the Publication tab in the “Planning” card.",
    "toolbar.userNeeds.service": "Service",
    "toolbar.userNeeds.service.description": "Give me tips and instructions",
    "toolbar.userNeeds.startAnalysis": "Start analysis",
    "toolbar.userNeeds.startAnalysis.disabled.blankOrDirty.tooltip": "The analysis cannot be started before the article is saved or if its content is blank.",
    "toolbar.userNeeds.startAnalysis.disabled.otherUserGenerating.tooltip": "Another user has already started user need generation. Once they are ready, you will see them in this tab.",
    "toolbar.userNeeds.startAnalysis.tooltip": "Every article should be written with a clear focus on one user need in order to best fulfil the needs of the reader. <spacer /> <linkIcon /> <linkComponent href='https://docs.google.com/document/d/1l64sYj9u8IyCS0moxdcA6_GSOU5nbVJD5wRb8QqEioU/edit?usp=sharing'>Tamedia User Needs Model</linkComponent",
    "toolbar.userNeeds.title": "User need",
    "toolbar.userNeeds.title.description": "Based on content analysis:",
    "toolbar.userNeeds.title.targetDescription": "Target:",
    "user.firstName": "First name",
    "user.fullName": "Name",
    "user.id": "User-ID",
    "user.jobTitle": "Job title",
    "user.lastName": "Last name",
    "user.list.addButton": "Add external account",
    "user.list.tab.all": "All",
    "user.list.tab.external": "External",
    "user.list.tab.internal": "Internal",
    "user.longBiography": "Long biography",
    "user.prolitterisId": "Prolitteris-ID",
    "user.shortBiography": "Short biography",
    "user.shortName": "Short name",
    "user.twitterHash": "X username",
    "user.userImage": "Profile picture",
    "userForm.editButton": "Edit",
    "userForm.oktaAccount": "Okta account",
    "userForm.title.create": "Create profile",
    "userForm.title.edit": "Profile",
    "userForm.title.tooltip": "The short biography is shown beneath the article, it has a maximum length of 180 characters. The long biography is shown on the author page (no maximum length). The biographies have to start with the name in bold: Surname Name […Text...]. The image has to be square (ideally: 350x350 Pixel).",
    "users.list.title": "Accounts",
    "userSettings.betaFeaturesEnabled.label": "Show beta features",
    "userSettings.language.deCh": "Deutsch",
    "userSettings.language.enGb": "English",
    "userSettings.language.frCh": "Français",
    "userSettings.title": "Preferences",
    "userSettings.uiLocale": "User interface language",
    "userSettings.uiLocaleDescription": "This setting affects the texts of the user interface such as labels and buttons.",
    "validate.team.teamsCollision": "Please choose two different teams",
    "validator.message.date": "Invalid date provided",
    "validator.message.deepLink": "Please enter a valid URL",
    "validator.message.hexadecimalColor": "Hex color code required (e.g. #DDEE55)",
    "validator.message.insecureUrl": "Please enter a valid URL",
    "validator.message.invalidEmbedCode": "Invalid embed code",
    "validator.message.invalidFrontendComponentUrl": "Invalid URL. It needs to contain \"tagesanzeiger.ch\"",
    "validator.message.invalidJson": "Invalid JSON",
    "validator.message.invalidJsonObject": "JSON must be an object",
    "validator.message.invalidProlitterisId": "Must be at most {{maxLength}} digits",
    "validator.message.invalidTimeFormat": "Invalid time provided",
    "validator.message.invalidTwitteUsername": "Allowed characters: \"a-z\", \"0-9\", \"_\" and at most 15 characters",
    "validator.message.isNotFutureDate": "Date must be in the future",
    "validator.message.isPastDate": "Date cannot be in the past",
    "validator.message.isPastTime": "Time cannot be in the past",
    "validator.message.livestreamVideoCmsError": "Invalid livestream videoCms embed code",
    "validator.message.maxLength": "Must be at most {{maxLength}} letters or symbols",
    "validator.message.minLength": "Must be at least {{minLength}} letters or symbols",
    "validator.message.noInternalUrl": "Internal URLs are not allowed",
    "validator.message.numbersOnly": "Must contain only digits",
    "validator.message.oneIframeOrUrl": "Please enter a valid and secure URL (https) or a correctly formatted iframe (<iframe></iframe> with https).",
    "validator.message.oneIframeUrlOrEmbedCode": "Please enter a valid, secure URL (https), a correctly formatted iframe (<iframe></iframe> using https), or a supported embed code (Glomex, JW Player, etc.).",
    "validator.message.path": "Path cannot contain symbols like:",
    "validator.message.required": "Required",
    "validator.message.secureUrl": "Please enter a secure (https) and valid URL",
    "validator.message.secureUrlOrMailto": "Please enter a secure (https) and valid URL, or a 'mailto:' link",
    "validator.message.startWithSlash": "Path must start with /",
    "validator.message.validUrlOrEmbedCode": "Please enter a valid URL, or an embed code",
    "validator.message.validUrlOrMailto": "Please enter a valid URL, or a 'mailto:' link",
    "validator.message.videoCmsError": "Invalid videoCms embed code",
    "validator.message.videoCmsVideoIdError": "Missing video id in the embed code",
    "validator.message.weightRange": "Must be between 0 and 1",
    "validator.notificationCategories.atLeastOneCategoryPerTenant": "Please select at least one category for {{ tenantNames }}.",
    "validators.urlSlug.allowedChars": "Allowed characters: \"a-z\", \"0-9\" and \"-\"",
    "validators.urlSlug.alreadyTaken": "This path is already taken.",
    "variants.selection.edit": "Change variants",
    "versionUsed": "Unity frontend version used: {{version}}",
    "video.form.intro": "Intro",
    "video.form.lead": "Lead",
    "video.form.title": "Title",
    "video.form.titleHeader": "Title header",
    "video.form.video": "Video",
    "video.setup.pageTitle": "New video",
    "videoUpload.error.noPreviewImage": "Please wait until the video preview image has been uploaded",
    "workflowChecklist": "Checklist",
    "workflowChecklist.noChanges": "No changes so far for this task",
    "workflowChecklist.photoeditingDone": "Photoediting",
    "workflowChecklist.productionDone": "Production",
    "workflowChecklist.proofreadingDone": "Proofreading",
    "workflowChecklist.seoDone": "SEO",
    "workflowChecklist.spellcheckingDone": "Spellchecker",
    "workflowChecklist.spellcheckingDone.disabled": "Open the Spellchecker to interact with this box"
}
